
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7pFJu", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $565b3d73b89576d4$export$6503ec6e8aabbaf; }, function (v) { return $565b3d73b89576d4$export$6503ec6e8aabbaf = v; });
var $565b3d73b89576d4$export$6503ec6e8aabbaf;
var $565b3d73b89576d4$export$f7ad0328861e2f03;
"use strict";
var $565b3d73b89576d4$var$mapping = new Map();
function $565b3d73b89576d4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$565b3d73b89576d4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $565b3d73b89576d4$var$resolve(id) {
    var resolved = $565b3d73b89576d4$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$565b3d73b89576d4$export$6503ec6e8aabbaf = $565b3d73b89576d4$var$register;
$565b3d73b89576d4$export$f7ad0328861e2f03 = $565b3d73b89576d4$var$resolve;

});

parcelRegister("gV3Os", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $c514ed589d6e37c6$export$bdfd709ae4826697; }, function (v) { return $c514ed589d6e37c6$export$bdfd709ae4826697 = v; });
var $c514ed589d6e37c6$export$bdfd709ae4826697;
var $c514ed589d6e37c6$export$c9e73fbda7da57b6;
var $c514ed589d6e37c6$export$5a759dc7a1cfb72a;
"use strict";
var $c514ed589d6e37c6$var$bundleURL = {};
function $c514ed589d6e37c6$var$getBundleURLCached(id) {
    var value = $c514ed589d6e37c6$var$bundleURL[id];
    if (!value) {
        value = $c514ed589d6e37c6$var$getBundleURL();
        $c514ed589d6e37c6$var$bundleURL[id] = value;
    }
    return value;
}
function $c514ed589d6e37c6$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $c514ed589d6e37c6$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $c514ed589d6e37c6$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $c514ed589d6e37c6$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$c514ed589d6e37c6$export$bdfd709ae4826697 = $c514ed589d6e37c6$var$getBundleURLCached;
$c514ed589d6e37c6$export$c9e73fbda7da57b6 = $c514ed589d6e37c6$var$getBaseURL;
$c514ed589d6e37c6$export$5a759dc7a1cfb72a = $c514ed589d6e37c6$var$getOrigin;

});

var $f044d4076a40af99$exports = {};


(parcelRequire("7pFJu")).register((parcelRequire("gV3Os")).getBundleURL('5QiRL'), JSON.parse("[\"5QiRL\",\"403.8a0470b3.js\",\"oW6mS\",\"calendar.8ac659bd.json\",\"9PjbO\",\"hashcache.7defbf8b.json\"]"));

function $fca1698b008d0cbb$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $606a30eea8e53e59$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fca1698b008d0cbb$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


const $7c407f4b455d38de$export$f2120bbfa5450bd2 = (collapse, year)=>`<svg class="news-arrow${collapse}" id="news-arrow-${year}" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1.5 16 16"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg>`;
const $7c407f4b455d38de$export$a80b3bd66acc52ff = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>`;


var $9bb5ebd5909e35c0$exports = {};
$9bb5ebd5909e35c0$exports = JSON.parse("{\"New Year's Day\":{\"isHoliday\":true,\"dates\":{\"2024-12-31\":\"9 AM - 4:30 PM\",\"2025-01-01\":\"CLOSED\"}},\"President's Day\":{\"isHoliday\":true,\"dates\":{\"2025-02-17\":\"CLOSED\"}},\"Good Friday\":{\"isHoliday\":true,\"dates\":{\"2025-04-18\":\"CLOSED\"}},\"Memorial Day\":{\"isHoliday\":true,\"dates\":{\"2025-05-26\":\"CLOSED\"}},\"Independence Day\":{\"isHoliday\":true,\"dates\":{\"2025-07-04\":\"CLOSED\"}},\"Labor Day\":{\"isHoliday\":true,\"dates\":{\"2025-09-01\":\"CLOSED\"}},\"Columbus Day\":{\"isHoliday\":true,\"dates\":{\"2025-10-13\":\"CLOSED\"}},\"Veterans' Day\":{\"isHoliday\":true,\"dates\":{\"2025-11-11\":\"CLOSED\"}},\"Thanksgiving\":{\"isHoliday\":true,\"dates\":{\"2025-11-26\":\"9 AM - 4:30 PM\",\"2025-11-27\":\"CLOSED\",\"2025-11-28\":\"CLOSED\"}},\"Christmas\":{\"isHoliday\":true,\"dates\":{\"2025-12-23\":\"9 AM - 4:30 PM\",\"2025-12-24\":\"CLOSED\",\"2025-12-25\":\"CLOSED\"}}}");


"use strict";


const $62d9c6abc6c16b60$export$461939dd4422153 = new Date("March 10 2025");
const $62d9c6abc6c16b60$export$89ae9bee9fce960e = $62d9c6abc6c16b60$export$461939dd4422153.getDay();
const $62d9c6abc6c16b60$export$44a7792e638edf8c = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $62d9c6abc6c16b60$export$a038b291f736c35e = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $62d9c6abc6c16b60$export$b7f7efbe9ab39b25 = (t)=>$62d9c6abc6c16b60$export$44a7792e638edf8c[t.getDay()];
const $62d9c6abc6c16b60$export$651581c3ee2374b0 = (t)=>`${$62d9c6abc6c16b60$export$b7f7efbe9ab39b25(t).slice(0, 3)}.`;
const $62d9c6abc6c16b60$export$af5de1609f06c8e6 = (t)=>$62d9c6abc6c16b60$export$a038b291f736c35e[t.getMonth()];
const $62d9c6abc6c16b60$export$c89bec1a34a35e6c = (t)=>`${$62d9c6abc6c16b60$export$af5de1609f06c8e6(t).slice(0, 3)}.`;
const $62d9c6abc6c16b60$export$371ef0f33bdee71f = 36e5;
const $62d9c6abc6c16b60$export$bb84506e5188b5b1 = $62d9c6abc6c16b60$export$371ef0f33bdee71f * 24;
const $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6 = (d, h)=>new Date(d.getTime() + h * $62d9c6abc6c16b60$export$371ef0f33bdee71f);
const $62d9c6abc6c16b60$export$dd412b56f1e4d8aa = (d, dd)=>new Date(d.getTime() + dd * $62d9c6abc6c16b60$export$bb84506e5188b5b1);
const $62d9c6abc6c16b60$export$3ae94a2503e890a1 = (n)=>{
    n = n.getDate();
    return n % 10 === 1 && n != 11 ? `${n}st` : n % 10 === 2 && n != 12 ? `${n}nd` : n % 10 === 3 && n != 13 ? `${n}rd` : `${n}th`;
};
const $62d9c6abc6c16b60$export$3203edd9e5edd663 = (d)=>{
    const hh = d.getHours();
    const m = d.getMinutes().toString().padStart(2, 0);
    const dd = hh >= 12 ? "PM" : "AM";
    let h = hh >= 12 ? hh - 12 : hh;
    h = h === 0 ? h = 12 : h;
    return `${h}:${m} ${dd}`;
};
const $62d9c6abc6c16b60$export$78a7e49ccc71dc8c = (date)=>date.toISOString().replace(/\d+Z/, 'Z').replaceAll(/[^\dTZ]+/g, '');
const $62d9c6abc6c16b60$export$eb66d2f1c11e30bf = (t)=>`${$62d9c6abc6c16b60$export$af5de1609f06c8e6(t)} ${$62d9c6abc6c16b60$export$3ae94a2503e890a1(t)}`;
const $62d9c6abc6c16b60$export$26e685d98fdeb12f = (t)=>`${$62d9c6abc6c16b60$export$651581c3ee2374b0(t)} ${$62d9c6abc6c16b60$export$af5de1609f06c8e6(t)} ${t.getDate()}`;
const $62d9c6abc6c16b60$export$9a60ba5ad633d9c0 = (t)=>`${$62d9c6abc6c16b60$export$b7f7efbe9ab39b25(t)}, ${$62d9c6abc6c16b60$export$eb66d2f1c11e30bf(t)}`;
const $62d9c6abc6c16b60$export$b3abad897351349f = (arr)=>{
    let splitter = [
        0
    ];
    for(let i = 1; i < arr.length; i++)if (arr[i].getMonth() !== arr[i - 1].getMonth()) splitter.push(i);
    splitter.push(arr.length);
    let output = [];
    let datestr;
    for(let i = 0; i < splitter.length - 1; i++){
        datestr = `${$62d9c6abc6c16b60$export$af5de1609f06c8e6(arr[splitter[i]])} `;
        for(let j = splitter[i]; j < splitter[i + 1]; j++){
            datestr += $62d9c6abc6c16b60$export$3ae94a2503e890a1(arr[j]);
            if (j < splitter[i + 1] - 1) datestr += `, `;
        }
        output.push(datestr);
    }
    return output;
};
const $62d9c6abc6c16b60$export$813e98560751a081 = ()=>{
    // Prune expired alerts
    const alerts = document.getElementById("alerts");
    if (alerts) {
        const alertList = Array.from(alerts.children);
        let activeAlerts = ``;
        alertList.forEach((alert)=>{
            const expiryTag = alert.dataset.expires;
            if (expiryTag === "" || expiryTag === undefined) activeAlerts += alert.outerHTML;
            else {
                const expiry = expiryTag.includes(":") ? new Date(expiryTag) : new Date(`${expiryTag} 8:00 PM`);
                if (expiry > $62d9c6abc6c16b60$export$461939dd4422153.getTime()) activeAlerts += alert.outerHTML;
            }
        });
        alerts.innerHTML = activeAlerts;
    }
    // Holiday alerts
    const holidayKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($9bb5ebd5909e35c0$exports))));
    holidayKeys.forEach((holiday)=>{
        const isHoliday = (0, (/*@__PURE__*/$parcel$interopDefault($9bb5ebd5909e35c0$exports)))[holiday].isHoliday;
        const holidayDates = (0, (/*@__PURE__*/$parcel$interopDefault($9bb5ebd5909e35c0$exports)))[holiday].dates;
        const dateKeys = Object.keys(holidayDates);
        // Get closing days
        let closings = dateKeys.filter((x)=>holidayDates[x] === 'CLOSED');
        // Get modified schedules
        let modDates = (0, $606a30eea8e53e59$export$71511d61b312f219)({}, holidayDates);
        Object.keys(modDates).forEach((x)=>{
            if (closings.includes(x)) delete modDates[x];
        });
        // Prepare alert string (closings)
        let closeStr, modStr;
        if (closings.length > 0) {
            const closeStart = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(closings[0]), 5);
            const closeEnd = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(closings[closings.length - 1]), 29);
            const closeEndName = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(closeEnd), -24);
            closeStr = `be closed ${closings.length > 1 ? `from <b>${$62d9c6abc6c16b60$export$9a60ba5ad633d9c0(closeStart)}</b> to <b>${$62d9c6abc6c16b60$export$9a60ba5ad633d9c0(closeEndName)}</b>` : `on <b>${$62d9c6abc6c16b60$export$9a60ba5ad633d9c0(closeStart)}</b>`}`;
        }
        // Prepare alert string (delays/early closings)
        // Handles only one modified schedule for now.
        if (Object.keys(modDates).length > 0) {
            const modKey = Object.keys(modDates)[0];
            const modDay = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(modKey), 5);
            const [modOpen, modClose] = modDates[modKey].split(' - ');
            modStr = `${modOpen !== '9 AM' ? `open at <b>${modOpen}` : `close at <b>${modClose}`}</b> on <b>${$62d9c6abc6c16b60$export$9a60ba5ad633d9c0(modDay)}</b>`;
        }
        // Concat + inject string
        const holidayStart = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(dateKeys[0]), 5);
        const holidayEnd = $62d9c6abc6c16b60$export$4a4306ad4fa0e5e6(new Date(dateKeys[dateKeys.length - 1]), -24);
        if (alerts && holidayStart.getTime() - $62d9c6abc6c16b60$export$461939dd4422153.getTime() <= $62d9c6abc6c16b60$export$bb84506e5188b5b1 * 14 && holidayEnd.getTime() - $62d9c6abc6c16b60$export$461939dd4422153.getTime() > 0) alerts.innerHTML = `${alerts.innerHTML}
            <div class="alert-info">
                ${$7c407f4b455d38de$export$a80b3bd66acc52ff}
                <span>Raritan Public Library will ${closeStr ? closeStr : modStr} ${isHoliday ? 'in observance of' : 'for'} <b>${holiday}</b>. ${modStr ? `The Library will also ${modStr}.` : ``}</span>
            </div>`;
    });
};


// Generate a request and response using a url and handling function
const $b3578e6e7db5838b$export$f46232c2a9c34923 = async (url, resFunc)=>{
    fetch(url).then((response)=>response.json()).then((data)=>resFunc(data)).catch((err)=>console.log(err));
};
const $b3578e6e7db5838b$export$842a2cf37af977e1 = (n, m)=>(n % m + m) % m;
const $b3578e6e7db5838b$export$5dc35a59ea5345f7 = (str)=>str.match('^http') ? `rel="noopener"` : ``;
const $b3578e6e7db5838b$export$d59f2f0b5faf7876 = (addCondition, removeCondition, ...pairs)=>{
    if (addCondition) pairs.forEach((pair)=>pair[0].classList.add(pair[1]));
    else if (removeCondition) pairs.forEach((pair)=>pair[0].classList.remove(pair[1]));
};
const $b3578e6e7db5838b$export$187b105aa6466800 = (func)=>{
    if (window.hasOwnProperty('ontouchstart')) window.addEventListener('touchstart', func);
    else window.addEventListener('click', func);
};
const $b3578e6e7db5838b$export$3ae65339208f6100 = (cat)=>{
    cat = cat.length === 1 ? cat[0].name : "";
    switch(cat){
        case "Holiday":
            return "crimson";
        case "Computers & Technology":
            return "red";
        case "Movie":
            return "orange";
        case "Health & Fitness":
            return "yellow";
        case "History":
            return "lime";
        case "ESL":
            return "green";
        case "Book Club":
            return "teal";
        case "Arts & Culture":
            return "cyan";
        case "Gaming":
            return "blue";
        case "Storytime":
            return "purple";
        case "Craft Program":
            return "pink";
        default:
            return "grey";
    }
};
const $b3578e6e7db5838b$export$3c49c185de0c2bfc = ()=>{
    return Math.max(document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
};
const $b3578e6e7db5838b$export$b141de964f0a90c1 = (max)=>{
    return Math.floor(Math.random() * max) + 1;
};



// Get an object with some important properties
const $915ccb9ee672fb9f$var$moreLinks = {
    "main": document.getElementById(`more`),
    "sub": document.getElementById(`more-content`),
    "arrow": document.querySelector(`#more > svg`)
};
// Conditional for clicking dropdowns
const $915ccb9ee672fb9f$var$dropdownClickLogic = (e)=>{
    $b3578e6e7db5838b$export$d59f2f0b5faf7876($915ccb9ee672fb9f$var$moreLinks.main.contains(e.target) && !$915ccb9ee672fb9f$var$moreLinks.sub.classList.contains("more-links-down"), !$915ccb9ee672fb9f$var$moreLinks.sub.contains(e.target) && $915ccb9ee672fb9f$var$moreLinks.sub.classList.contains("more-links-down"), [
        $915ccb9ee672fb9f$var$moreLinks.sub,
        "more-links-down"
    ], [
        $915ccb9ee672fb9f$var$moreLinks.arrow,
        "rotate180"
    ]);
};
// Conditional for dropdowns via keyboard input
const $915ccb9ee672fb9f$var$dropdownKeyLogic = (tab, e)=>{
    $b3578e6e7db5838b$export$d59f2f0b5faf7876(e.key === "Tab" && tab === `more` && !$915ccb9ee672fb9f$var$moreLinks.sub.classList.contains("more-links-down"), e.key === "Tab" && tab !== `more` && $915ccb9ee672fb9f$var$moreLinks.sub.classList.contains("more-links-down"), [
        $915ccb9ee672fb9f$var$moreLinks.sub,
        "more-links-down"
    ], [
        $915ccb9ee672fb9f$var$moreLinks.arrow,
        "rotate180"
    ]);
};
const $915ccb9ee672fb9f$export$81207e5cc4186890 = ()=>{
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        $915ccb9ee672fb9f$var$dropdownClickLogic(e);
    });
    window.addEventListener('keyup', (e)=>{
        let tabbed;
        try {
            tabbed = document.activeElement.id || document.activeElement.parentElement.parentElement.id;
        } catch (error) {
            tabbed = document.activeElement.id;
        }
        $915ccb9ee672fb9f$var$dropdownKeyLogic(tabbed, e);
    });
};
const $915ccb9ee672fb9f$export$4bd4b47501432316 = ()=>{
    let xDown = null;
    document.addEventListener('touchstart', (e)=>{
        const firstTouch = e.touches[0];
        xDown = firstTouch.clientX;
    });
    document.addEventListener('touchmove', (e)=>{
        if (!xDown) return;
        let xUp = e.touches[0].clientX;
        let xDiff = xDown - xUp;
        if (Math.abs(xDiff) > 10 && document.documentElement.scrollTop < 20) {
            const links = document.getElementById("links");
            const menuIcon = document.querySelector(".nav-toggle > svg");
            const main = document.querySelector(".main");
            const page = document.querySelector("html");
            $b3578e6e7db5838b$export$d59f2f0b5faf7876(!menuIcon.classList.contains("enlarge") && xDiff > 0, menuIcon.classList.contains("enlarge") && xDiff < 0, [
                links,
                "links-open"
            ], [
                menuIcon,
                "enlarge"
            ], [
                main,
                "darken",
                "freeze"
            ], [
                page,
                "freeze"
            ]);
        }
        xDown = null;
    });
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        const links = document.getElementById("links");
        const menu = document.getElementById("nav-toggle");
        const menuIcon = document.querySelector(".nav-toggle > svg");
        const main = document.querySelector(".main");
        const themeButton = document.getElementById("theme");
        const page = document.querySelector("html");
        $b3578e6e7db5838b$export$d59f2f0b5faf7876(menu.contains(e.target) && !menuIcon.classList.contains("enlarge"), !links.contains(e.target) && menuIcon.classList.contains("enlarge"), [
            links,
            "links-open"
        ], [
            menuIcon,
            "enlarge"
        ], [
            main,
            "darken",
            "freeze"
        ], [
            themeButton,
            "theme-darken"
        ], [
            page,
            "freeze"
        ]);
    });
};





/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */ function $768caab3beb865fd$var$isNothing(subject) {
    return typeof subject === 'undefined' || subject === null;
}
function $768caab3beb865fd$var$isObject(subject) {
    return typeof subject === 'object' && subject !== null;
}
function $768caab3beb865fd$var$toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if ($768caab3beb865fd$var$isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function $768caab3beb865fd$var$extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function $768caab3beb865fd$var$repeat(string, count) {
    var result = '', cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function $768caab3beb865fd$var$isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var $768caab3beb865fd$var$isNothing_1 = $768caab3beb865fd$var$isNothing;
var $768caab3beb865fd$var$isObject_1 = $768caab3beb865fd$var$isObject;
var $768caab3beb865fd$var$toArray_1 = $768caab3beb865fd$var$toArray;
var $768caab3beb865fd$var$repeat_1 = $768caab3beb865fd$var$repeat;
var $768caab3beb865fd$var$isNegativeZero_1 = $768caab3beb865fd$var$isNegativeZero;
var $768caab3beb865fd$var$extend_1 = $768caab3beb865fd$var$extend;
var $768caab3beb865fd$var$common = {
    isNothing: $768caab3beb865fd$var$isNothing_1,
    isObject: $768caab3beb865fd$var$isObject_1,
    toArray: $768caab3beb865fd$var$toArray_1,
    repeat: $768caab3beb865fd$var$repeat_1,
    isNegativeZero: $768caab3beb865fd$var$isNegativeZero_1,
    extend: $768caab3beb865fd$var$extend_1
};
// YAML error class. http://stackoverflow.com/questions/8458984
function $768caab3beb865fd$var$formatError(exception, compact) {
    var where = '', message = exception.reason || '(unknown reason)';
    if (!exception.mark) return message;
    if (exception.mark.name) where += 'in "' + exception.mark.name + '" ';
    where += '(' + (exception.mark.line + 1) + ':' + (exception.mark.column + 1) + ')';
    if (!compact && exception.mark.snippet) where += '\n\n' + exception.mark.snippet;
    return message + ' ' + where;
}
function $768caab3beb865fd$var$YAMLException$1(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = $768caab3beb865fd$var$formatError(this, false);
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
}
// Inherit from Error
$768caab3beb865fd$var$YAMLException$1.prototype = Object.create(Error.prototype);
$768caab3beb865fd$var$YAMLException$1.prototype.constructor = $768caab3beb865fd$var$YAMLException$1;
$768caab3beb865fd$var$YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ': ' + $768caab3beb865fd$var$formatError(this, compact);
};
var $768caab3beb865fd$var$exception = $768caab3beb865fd$var$YAMLException$1;
// get snippet for a single line, respecting maxLength
function $768caab3beb865fd$var$getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = '';
    var tail = '';
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = ' ... ';
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = ' ...';
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length // relative position
    };
}
function $768caab3beb865fd$var$padStart(string, max) {
    return $768caab3beb865fd$var$common.repeat(' ', max - string.length) + string;
}
function $768caab3beb865fd$var$makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== 'number') options.indent = 1;
    if (typeof options.linesBefore !== 'number') options.linesBefore = 3;
    if (typeof options.linesAfter !== 'number') options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = '', i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = $768caab3beb865fd$var$getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = $768caab3beb865fd$var$common.repeat(' ', options.indent) + $768caab3beb865fd$var$padStart((mark.line - i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n' + result;
    }
    line = $768caab3beb865fd$var$getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += $768caab3beb865fd$var$common.repeat(' ', options.indent) + $768caab3beb865fd$var$padStart((mark.line + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    result += $768caab3beb865fd$var$common.repeat('-', options.indent + lineNoLength + 3 + line.pos) + '^' + '\n';
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = $768caab3beb865fd$var$getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += $768caab3beb865fd$var$common.repeat(' ', options.indent) + $768caab3beb865fd$var$padStart((mark.line + i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    }
    return result.replace(/\n$/, '');
}
var $768caab3beb865fd$var$snippet = $768caab3beb865fd$var$makeSnippet;
var $768caab3beb865fd$var$TYPE_CONSTRUCTOR_OPTIONS = [
    'kind',
    'multi',
    'resolve',
    'construct',
    'instanceOf',
    'predicate',
    'represent',
    'representName',
    'defaultStyle',
    'styleAliases'
];
var $768caab3beb865fd$var$YAML_NODE_KINDS = [
    'scalar',
    'sequence',
    'mapping'
];
function $768caab3beb865fd$var$compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function $768caab3beb865fd$var$Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if ($768caab3beb865fd$var$TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new $768caab3beb865fd$var$exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.options = options; // keep original options in case user wants to extend this type later
    this.tag = tag;
    this.kind = options['kind'] || null;
    this.resolve = options['resolve'] || function() {
        return true;
    };
    this.construct = options['construct'] || function(data) {
        return data;
    };
    this.instanceOf = options['instanceOf'] || null;
    this.predicate = options['predicate'] || null;
    this.represent = options['represent'] || null;
    this.representName = options['representName'] || null;
    this.defaultStyle = options['defaultStyle'] || null;
    this.multi = options['multi'] || false;
    this.styleAliases = $768caab3beb865fd$var$compileStyleAliases(options['styleAliases'] || null);
    if ($768caab3beb865fd$var$YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new $768caab3beb865fd$var$exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var $768caab3beb865fd$var$type = $768caab3beb865fd$var$Type$1;
/*eslint-disable max-len*/ function $768caab3beb865fd$var$compileList(schema, name) {
    var result = [];
    schema[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function $768caab3beb865fd$var$compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type) {
        if (type.multi) {
            result.multi[type.kind].push(type);
            result.multi['fallback'].push(type);
        } else result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function $768caab3beb865fd$var$Schema$1(definition) {
    return this.extend(definition);
}
$768caab3beb865fd$var$Schema$1.prototype.extend = function extend(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof $768caab3beb865fd$var$type) // Schema.extend(type)
    explicit.push(definition);
    else if (Array.isArray(definition)) // Schema.extend([ type1, type2, ... ])
    explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new $768caab3beb865fd$var$exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof $768caab3beb865fd$var$type)) throw new $768caab3beb865fd$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
        if (type$1.loadKind && type$1.loadKind !== 'scalar') throw new $768caab3beb865fd$var$exception('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
        if (type$1.multi) throw new $768caab3beb865fd$var$exception('There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.');
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof $768caab3beb865fd$var$type)) throw new $768caab3beb865fd$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    });
    var result = Object.create($768caab3beb865fd$var$Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = $768caab3beb865fd$var$compileList(result, 'implicit');
    result.compiledExplicit = $768caab3beb865fd$var$compileList(result, 'explicit');
    result.compiledTypeMap = $768caab3beb865fd$var$compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var $768caab3beb865fd$var$schema = $768caab3beb865fd$var$Schema$1;
var $768caab3beb865fd$var$str = new $768caab3beb865fd$var$type('tag:yaml.org,2002:str', {
    kind: 'scalar',
    construct: function(data) {
        return data !== null ? data : '';
    }
});
var $768caab3beb865fd$var$seq = new $768caab3beb865fd$var$type('tag:yaml.org,2002:seq', {
    kind: 'sequence',
    construct: function(data) {
        return data !== null ? data : [];
    }
});
var $768caab3beb865fd$var$map = new $768caab3beb865fd$var$type('tag:yaml.org,2002:map', {
    kind: 'mapping',
    construct: function(data) {
        return data !== null ? data : {};
    }
});
var $768caab3beb865fd$var$failsafe = new $768caab3beb865fd$var$schema({
    explicit: [
        $768caab3beb865fd$var$str,
        $768caab3beb865fd$var$seq,
        $768caab3beb865fd$var$map
    ]
});
function $768caab3beb865fd$var$resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function $768caab3beb865fd$var$constructYamlNull() {
    return null;
}
function $768caab3beb865fd$var$isNull(object) {
    return object === null;
}
var $768caab3beb865fd$var$_null = new $768caab3beb865fd$var$type('tag:yaml.org,2002:null', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlNull,
    construct: $768caab3beb865fd$var$constructYamlNull,
    predicate: $768caab3beb865fd$var$isNull,
    represent: {
        canonical: function() {
            return '~';
        },
        lowercase: function() {
            return 'null';
        },
        uppercase: function() {
            return 'NULL';
        },
        camelcase: function() {
            return 'Null';
        },
        empty: function() {
            return '';
        }
    },
    defaultStyle: 'lowercase'
});
function $768caab3beb865fd$var$resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function $768caab3beb865fd$var$constructYamlBoolean(data) {
    return data === 'true' || data === 'True' || data === 'TRUE';
}
function $768caab3beb865fd$var$isBoolean(object) {
    return Object.prototype.toString.call(object) === '[object Boolean]';
}
var $768caab3beb865fd$var$bool = new $768caab3beb865fd$var$type('tag:yaml.org,2002:bool', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlBoolean,
    construct: $768caab3beb865fd$var$constructYamlBoolean,
    predicate: $768caab3beb865fd$var$isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? 'true' : 'false';
        },
        uppercase: function(object) {
            return object ? 'TRUE' : 'FALSE';
        },
        camelcase: function(object) {
            return object ? 'True' : 'False';
        }
    },
    defaultStyle: 'lowercase'
});
function $768caab3beb865fd$var$isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function $768caab3beb865fd$var$isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function $768caab3beb865fd$var$isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function $768caab3beb865fd$var$resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === '-' || ch === '+') ch = data[++index];
    if (ch === '0') {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === 'b') {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (ch !== '0' && ch !== '1') return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'x') {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$768caab3beb865fd$var$isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'o') {
            // base 8
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$768caab3beb865fd$var$isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
    }
    // base 10 (except 0)
    // value should not start with `_`;
    if (ch === '_') return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === '_') continue;
        if (!$768caab3beb865fd$var$isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === '_') return false;
    return true;
}
function $768caab3beb865fd$var$constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf('_') !== -1) value = value.replace(/_/g, '');
    ch = value[0];
    if (ch === '-' || ch === '+') {
        if (ch === '-') sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === '0') return 0;
    if (ch === '0') {
        if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
        if (value[1] === 'x') return sign * parseInt(value.slice(2), 16);
        if (value[1] === 'o') return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function $768caab3beb865fd$var$isInteger(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !$768caab3beb865fd$var$common.isNegativeZero(object);
}
var $768caab3beb865fd$var$int = new $768caab3beb865fd$var$type('tag:yaml.org,2002:int', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlInteger,
    construct: $768caab3beb865fd$var$constructYamlInteger,
    predicate: $768caab3beb865fd$var$isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? '0o' + obj.toString(8) : '-0o' + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: 'decimal',
    styleAliases: {
        binary: [
            2,
            'bin'
        ],
        octal: [
            8,
            'oct'
        ],
        decimal: [
            10,
            'dec'
        ],
        hexadecimal: [
            16,
            'hex'
        ]
    }
});
var $768caab3beb865fd$var$YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function $768caab3beb865fd$var$resolveYamlFloat(data) {
    if (data === null) return false;
    if (!$768caab3beb865fd$var$YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === '_') return false;
    return true;
}
function $768caab3beb865fd$var$constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, '').toLowerCase();
    sign = value[0] === '-' ? -1 : 1;
    if ('+-'.indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === '.inf') return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === '.nan') return NaN;
    return sign * parseFloat(value, 10);
}
var $768caab3beb865fd$var$SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function $768caab3beb865fd$var$representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case 'lowercase':
            return '.nan';
        case 'uppercase':
            return '.NAN';
        case 'camelcase':
            return '.NaN';
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '.inf';
        case 'uppercase':
            return '.INF';
        case 'camelcase':
            return '.Inf';
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '-.inf';
        case 'uppercase':
            return '-.INF';
        case 'camelcase':
            return '-.Inf';
    }
    else if ($768caab3beb865fd$var$common.isNegativeZero(object)) return '-0.0';
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return $768caab3beb865fd$var$SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function $768caab3beb865fd$var$isFloat(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || $768caab3beb865fd$var$common.isNegativeZero(object));
}
var $768caab3beb865fd$var$float = new $768caab3beb865fd$var$type('tag:yaml.org,2002:float', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlFloat,
    construct: $768caab3beb865fd$var$constructYamlFloat,
    predicate: $768caab3beb865fd$var$isFloat,
    represent: $768caab3beb865fd$var$representYamlFloat,
    defaultStyle: 'lowercase'
});
var $768caab3beb865fd$var$json = $768caab3beb865fd$var$failsafe.extend({
    implicit: [
        $768caab3beb865fd$var$_null,
        $768caab3beb865fd$var$bool,
        $768caab3beb865fd$var$int,
        $768caab3beb865fd$var$float
    ]
});
var $768caab3beb865fd$var$core = $768caab3beb865fd$var$json;
var $768caab3beb865fd$var$YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var $768caab3beb865fd$var$YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function $768caab3beb865fd$var$resolveYamlTimestamp(data) {
    if (data === null) return false;
    if ($768caab3beb865fd$var$YAML_DATE_REGEXP.exec(data) !== null) return true;
    if ($768caab3beb865fd$var$YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function $768caab3beb865fd$var$constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = $768caab3beb865fd$var$YAML_DATE_REGEXP.exec(data);
    if (match === null) match = $768caab3beb865fd$var$YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error('Date resolve error');
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += '0';
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === '-') delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function $768caab3beb865fd$var$representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
var $768caab3beb865fd$var$timestamp = new $768caab3beb865fd$var$type('tag:yaml.org,2002:timestamp', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlTimestamp,
    construct: $768caab3beb865fd$var$constructYamlTimestamp,
    instanceOf: Date,
    represent: $768caab3beb865fd$var$representYamlTimestamp
});
function $768caab3beb865fd$var$resolveYamlMerge(data) {
    return data === '<<' || data === null;
}
var $768caab3beb865fd$var$merge = new $768caab3beb865fd$var$type('tag:yaml.org,2002:merge', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlMerge
});
/*eslint-disable no-bitwise*/ // [ 64, 65, 66 ] -> [ padding, CR, LF ]
var $768caab3beb865fd$var$BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function $768caab3beb865fd$var$resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = $768caab3beb865fd$var$BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function $768caab3beb865fd$var$constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ''), max = input.length, map = $768caab3beb865fd$var$BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    return new Uint8Array(result);
}
function $768caab3beb865fd$var$representYamlBinary(object /*, style*/ ) {
    var result = '', bits = 0, idx, tail, max = object.length, map = $768caab3beb865fd$var$BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function $768caab3beb865fd$var$isBinary(obj) {
    return Object.prototype.toString.call(obj) === '[object Uint8Array]';
}
var $768caab3beb865fd$var$binary = new $768caab3beb865fd$var$type('tag:yaml.org,2002:binary', {
    kind: 'scalar',
    resolve: $768caab3beb865fd$var$resolveYamlBinary,
    construct: $768caab3beb865fd$var$constructYamlBinary,
    predicate: $768caab3beb865fd$var$isBinary,
    represent: $768caab3beb865fd$var$representYamlBinary
});
var $768caab3beb865fd$var$_hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var $768caab3beb865fd$var$_toString$2 = Object.prototype.toString;
function $768caab3beb865fd$var$resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if ($768caab3beb865fd$var$_toString$2.call(pair) !== '[object Object]') return false;
        for(pairKey in pair)if ($768caab3beb865fd$var$_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function $768caab3beb865fd$var$constructYamlOmap(data) {
    return data !== null ? data : [];
}
var $768caab3beb865fd$var$omap = new $768caab3beb865fd$var$type('tag:yaml.org,2002:omap', {
    kind: 'sequence',
    resolve: $768caab3beb865fd$var$resolveYamlOmap,
    construct: $768caab3beb865fd$var$constructYamlOmap
});
var $768caab3beb865fd$var$_toString$1 = Object.prototype.toString;
function $768caab3beb865fd$var$resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if ($768caab3beb865fd$var$_toString$1.call(pair) !== '[object Object]') return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function $768caab3beb865fd$var$constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var $768caab3beb865fd$var$pairs = new $768caab3beb865fd$var$type('tag:yaml.org,2002:pairs', {
    kind: 'sequence',
    resolve: $768caab3beb865fd$var$resolveYamlPairs,
    construct: $768caab3beb865fd$var$constructYamlPairs
});
var $768caab3beb865fd$var$_hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function $768caab3beb865fd$var$resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if ($768caab3beb865fd$var$_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function $768caab3beb865fd$var$constructYamlSet(data) {
    return data !== null ? data : {};
}
var $768caab3beb865fd$var$set = new $768caab3beb865fd$var$type('tag:yaml.org,2002:set', {
    kind: 'mapping',
    resolve: $768caab3beb865fd$var$resolveYamlSet,
    construct: $768caab3beb865fd$var$constructYamlSet
});
var $768caab3beb865fd$var$_default = $768caab3beb865fd$var$core.extend({
    implicit: [
        $768caab3beb865fd$var$timestamp,
        $768caab3beb865fd$var$merge
    ],
    explicit: [
        $768caab3beb865fd$var$binary,
        $768caab3beb865fd$var$omap,
        $768caab3beb865fd$var$pairs,
        $768caab3beb865fd$var$set
    ]
});
/*eslint-disable max-len,no-use-before-define*/ var $768caab3beb865fd$var$_hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $768caab3beb865fd$var$CONTEXT_FLOW_IN = 1;
var $768caab3beb865fd$var$CONTEXT_FLOW_OUT = 2;
var $768caab3beb865fd$var$CONTEXT_BLOCK_IN = 3;
var $768caab3beb865fd$var$CONTEXT_BLOCK_OUT = 4;
var $768caab3beb865fd$var$CHOMPING_CLIP = 1;
var $768caab3beb865fd$var$CHOMPING_STRIP = 2;
var $768caab3beb865fd$var$CHOMPING_KEEP = 3;
var $768caab3beb865fd$var$PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var $768caab3beb865fd$var$PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var $768caab3beb865fd$var$PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var $768caab3beb865fd$var$PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var $768caab3beb865fd$var$PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function $768caab3beb865fd$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $768caab3beb865fd$var$is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $768caab3beb865fd$var$is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function $768caab3beb865fd$var$is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $768caab3beb865fd$var$is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function $768caab3beb865fd$var$fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function $768caab3beb865fd$var$escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function $768caab3beb865fd$var$fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function $768caab3beb865fd$var$simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? '\x00' : c === 0x61 /* a */  ? '\x07' : c === 0x62 /* b */  ? '\x08' : c === 0x74 /* t */  ? '\x09' : c === 0x09 /* Tab */  ? '\x09' : c === 0x6E /* n */  ? '\x0A' : c === 0x76 /* v */  ? '\x0B' : c === 0x66 /* f */  ? '\x0C' : c === 0x72 /* r */  ? '\x0D' : c === 0x65 /* e */  ? '\x1B' : c === 0x20 /* Space */  ? ' ' : c === 0x22 /* " */  ? '\x22' : c === 0x2F /* / */  ? '/' : c === 0x5C /* \ */  ? '\x5C' : c === 0x4E /* N */  ? '\x85' : c === 0x5F /* _ */  ? '\xA0' : c === 0x4C /* L */  ? '\u2028' : c === 0x50 /* P */  ? '\u2029' : '';
}
function $768caab3beb865fd$var$charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
var $768caab3beb865fd$var$simpleEscapeCheck = new Array(256); // integer, for fast access
var $768caab3beb865fd$var$simpleEscapeMap = new Array(256);
for(var $768caab3beb865fd$var$i = 0; $768caab3beb865fd$var$i < 256; $768caab3beb865fd$var$i++){
    $768caab3beb865fd$var$simpleEscapeCheck[$768caab3beb865fd$var$i] = $768caab3beb865fd$var$simpleEscapeSequence($768caab3beb865fd$var$i) ? 1 : 0;
    $768caab3beb865fd$var$simpleEscapeMap[$768caab3beb865fd$var$i] = $768caab3beb865fd$var$simpleEscapeSequence($768caab3beb865fd$var$i);
}
function $768caab3beb865fd$var$State$1(input, options) {
    this.input = input;
    this.filename = options['filename'] || null;
    this.schema = options['schema'] || $768caab3beb865fd$var$_default;
    this.onWarning = options['onWarning'] || null;
    // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
    // if such documents have no explicit %YAML directive
    this.legacy = options['legacy'] || false;
    this.json = options['json'] || false;
    this.listener = options['listener'] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    // position of first leading tab in the current line,
    // used to make sure there are no tabs in the indentation
    this.firstTabInLine = -1;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function $768caab3beb865fd$var$generateError(state, message) {
    var mark = {
        name: state.filename,
        buffer: state.input.slice(0, -1),
        position: state.position,
        line: state.line,
        column: state.position - state.lineStart
    };
    mark.snippet = $768caab3beb865fd$var$snippet(mark);
    return new $768caab3beb865fd$var$exception(message, mark);
}
function $768caab3beb865fd$var$throwError(state, message) {
    throw $768caab3beb865fd$var$generateError(state, message);
}
function $768caab3beb865fd$var$throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, $768caab3beb865fd$var$generateError(state, message));
}
var $768caab3beb865fd$var$directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) $768caab3beb865fd$var$throwError(state, 'duplication of %YAML directive');
        if (args.length !== 1) $768caab3beb865fd$var$throwError(state, 'YAML directive accepts exactly one argument');
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) $768caab3beb865fd$var$throwError(state, 'ill-formed argument of the YAML directive');
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) $768caab3beb865fd$var$throwError(state, 'unacceptable YAML version of the document');
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) $768caab3beb865fd$var$throwWarning(state, 'unsupported YAML version of the document');
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) $768caab3beb865fd$var$throwError(state, 'TAG directive accepts exactly two arguments');
        handle = args[0];
        prefix = args[1];
        if (!$768caab3beb865fd$var$PATTERN_TAG_HANDLE.test(handle)) $768caab3beb865fd$var$throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
        if ($768caab3beb865fd$var$_hasOwnProperty$1.call(state.tagMap, handle)) $768caab3beb865fd$var$throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!$768caab3beb865fd$var$PATTERN_TAG_URI.test(prefix)) $768caab3beb865fd$var$throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            $768caab3beb865fd$var$throwError(state, 'tag prefix is malformed: ' + prefix);
        }
        state.tagMap[handle] = prefix;
    }
};
function $768caab3beb865fd$var$captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) $768caab3beb865fd$var$throwError(state, 'expected valid JSON character');
        }
        else if ($768caab3beb865fd$var$PATTERN_NON_PRINTABLE.test(_result)) $768caab3beb865fd$var$throwError(state, 'the stream contains non-printable characters');
        state.result += _result;
    }
}
function $768caab3beb865fd$var$mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!$768caab3beb865fd$var$common.isObject(source)) $768caab3beb865fd$var$throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!$768caab3beb865fd$var$_hasOwnProperty$1.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) $768caab3beb865fd$var$throwError(state, 'nested arrays are not supported inside keys');
            if (typeof keyNode === 'object' && $768caab3beb865fd$var$_class(keyNode[index]) === '[object Object]') keyNode[index] = '[object Object]';
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if (typeof keyNode === 'object' && $768caab3beb865fd$var$_class(keyNode) === '[object Object]') keyNode = '[object Object]';
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === 'tag:yaml.org,2002:merge') {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)$768caab3beb865fd$var$mergeMappings(state, _result, valueNode[index], overridableKeys);
        else $768caab3beb865fd$var$mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !$768caab3beb865fd$var$_hasOwnProperty$1.call(overridableKeys, keyNode) && $768caab3beb865fd$var$_hasOwnProperty$1.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.lineStart = startLineStart || state.lineStart;
            state.position = startPos || state.position;
            $768caab3beb865fd$var$throwError(state, 'duplicated mapping key');
        }
        // used for this specific key only because Object.defineProperty is slow
        if (keyNode === '__proto__') Object.defineProperty(_result, keyNode, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: valueNode
        });
        else _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function $768caab3beb865fd$var$readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else $768caab3beb865fd$var$throwError(state, 'a line break is expected');
    state.line += 1;
    state.lineStart = state.position;
    state.firstTabInLine = -1;
}
function $768caab3beb865fd$var$skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while($768caab3beb865fd$var$is_WHITE_SPACE(ch)){
            if (ch === 0x09 /* Tab */  && state.firstTabInLine === -1) state.firstTabInLine = state.position;
            ch = state.input.charCodeAt(++state.position);
        }
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if ($768caab3beb865fd$var$is_EOL(ch)) {
            $768caab3beb865fd$var$readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) $768caab3beb865fd$var$throwWarning(state, 'deficient indentation');
    return lineBreaks;
}
function $768caab3beb865fd$var$testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || $768caab3beb865fd$var$is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function $768caab3beb865fd$var$writeFoldedLines(state, count) {
    if (count === 1) state.result += ' ';
    else if (count > 1) state.result += $768caab3beb865fd$var$common.repeat('\n', count - 1);
}
function $768caab3beb865fd$var$readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if ($768caab3beb865fd$var$is_WS_OR_EOL(ch) || $768caab3beb865fd$var$is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if ($768caab3beb865fd$var$is_WS_OR_EOL(following) || withinFlowCollection && $768caab3beb865fd$var$is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = 'scalar';
    state.result = '';
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($768caab3beb865fd$var$is_WS_OR_EOL(following) || withinFlowCollection && $768caab3beb865fd$var$is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if ($768caab3beb865fd$var$is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && $768caab3beb865fd$var$testDocumentSeparator(state) || withinFlowCollection && $768caab3beb865fd$var$is_FLOW_INDICATOR(ch)) break;
        else if ($768caab3beb865fd$var$is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            $768caab3beb865fd$var$skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, captureEnd, false);
            $768caab3beb865fd$var$writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!$768caab3beb865fd$var$is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    $768caab3beb865fd$var$captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function $768caab3beb865fd$var$readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if ($768caab3beb865fd$var$is_EOL(ch)) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, captureEnd, true);
            $768caab3beb865fd$var$writeFoldedLines(state, $768caab3beb865fd$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $768caab3beb865fd$var$testDocumentSeparator(state)) $768caab3beb865fd$var$throwError(state, 'unexpected end of the document within a single quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $768caab3beb865fd$var$throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function $768caab3beb865fd$var$readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if ($768caab3beb865fd$var$is_EOL(ch)) $768caab3beb865fd$var$skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && $768caab3beb865fd$var$simpleEscapeCheck[ch]) {
                state.result += $768caab3beb865fd$var$simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = $768caab3beb865fd$var$escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = $768caab3beb865fd$var$fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else $768caab3beb865fd$var$throwError(state, 'expected hexadecimal character');
                }
                state.result += $768caab3beb865fd$var$charFromCodepoint(hexResult);
                state.position++;
            } else $768caab3beb865fd$var$throwError(state, 'unknown escape sequence');
            captureStart = captureEnd = state.position;
        } else if ($768caab3beb865fd$var$is_EOL(ch)) {
            $768caab3beb865fd$var$captureSegment(state, captureStart, captureEnd, true);
            $768caab3beb865fd$var$writeFoldedLines(state, $768caab3beb865fd$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $768caab3beb865fd$var$testDocumentSeparator(state)) $768caab3beb865fd$var$throwError(state, 'unexpected end of the document within a double quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $768caab3beb865fd$var$throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function $768caab3beb865fd$var$readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        $768caab3beb865fd$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? 'mapping' : 'sequence';
            state.result = _result;
            return true;
        } else if (!readNext) $768caab3beb865fd$var$throwError(state, 'missed comma between flow collection entries');
        else if (ch === 0x2C /* , */ ) // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
        $768caab3beb865fd$var$throwError(state, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($768caab3beb865fd$var$is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                $768caab3beb865fd$var$skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line; // Save the current line.
        _lineStart = state.lineStart;
        _pos = state.position;
        $768caab3beb865fd$var$composeNode(state, nodeIndent, $768caab3beb865fd$var$CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        $768caab3beb865fd$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            $768caab3beb865fd$var$skipSeparationSpace(state, true, nodeIndent);
            $768caab3beb865fd$var$composeNode(state, nodeIndent, $768caab3beb865fd$var$CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push($768caab3beb865fd$var$storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        $768caab3beb865fd$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    $768caab3beb865fd$var$throwError(state, 'unexpected end of the stream within a flow collection');
}
function $768caab3beb865fd$var$readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = $768caab3beb865fd$var$CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = 'scalar';
    state.result = '';
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if ($768caab3beb865fd$var$CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? $768caab3beb865fd$var$CHOMPING_KEEP : $768caab3beb865fd$var$CHOMPING_STRIP;
            else $768caab3beb865fd$var$throwError(state, 'repeat of a chomping mode identifier');
        } else if ((tmp = $768caab3beb865fd$var$fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) $768caab3beb865fd$var$throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else $768caab3beb865fd$var$throwError(state, 'repeat of an indentation width identifier');
        } else break;
    }
    if ($768caab3beb865fd$var$is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while ($768caab3beb865fd$var$is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!$768caab3beb865fd$var$is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        $768caab3beb865fd$var$readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if ($768caab3beb865fd$var$is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === $768caab3beb865fd$var$CHOMPING_KEEP) state.result += $768caab3beb865fd$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === $768caab3beb865fd$var$CHOMPING_CLIP) {
                if (didReadContent) state.result += '\n';
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if ($768caab3beb865fd$var$is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += $768caab3beb865fd$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += $768caab3beb865fd$var$common.repeat('\n', emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += ' ';
            } else state.result += $768caab3beb865fd$var$common.repeat('\n', emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += $768caab3beb865fd$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!$768caab3beb865fd$var$is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        $768caab3beb865fd$var$captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function $768caab3beb865fd$var$readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $768caab3beb865fd$var$throwError(state, 'tab characters must not be used in indentation');
        }
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!$768caab3beb865fd$var$is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if ($768caab3beb865fd$var$skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        $768caab3beb865fd$var$composeNode(state, nodeIndent, $768caab3beb865fd$var$CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $768caab3beb865fd$var$throwError(state, 'bad indentation of a sequence entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'sequence';
        state.result = _result;
        return true;
    }
    return false;
}
function $768caab3beb865fd$var$readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (!atExplicitKey && state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $768caab3beb865fd$var$throwError(state, 'tab characters must not be used in indentation');
        }
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && $768caab3beb865fd$var$is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else $768caab3beb865fd$var$throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else {
            _keyLine = state.line;
            _keyLineStart = state.lineStart;
            _keyPos = state.position;
            if (!$768caab3beb865fd$var$composeNode(state, flowIndent, $768caab3beb865fd$var$CONTEXT_FLOW_OUT, false, true)) break;
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while($768caab3beb865fd$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!$768caab3beb865fd$var$is_WS_OR_EOL(ch)) $768caab3beb865fd$var$throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
                    if (atExplicitKey) {
                        $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) $768caab3beb865fd$var$throwError(state, 'can not read an implicit mapping pair; a colon is missed');
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) $768caab3beb865fd$var$throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        }
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state.line;
                _keyLineStart = state.lineStart;
                _keyPos = state.position;
            }
            if ($768caab3beb865fd$var$composeNode(state, nodeIndent, $768caab3beb865fd$var$CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $768caab3beb865fd$var$throwError(state, 'bad indentation of a mapping entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) $768caab3beb865fd$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'mapping';
        state.result = _result;
    }
    return detected;
}
function $768caab3beb865fd$var$readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) $768caab3beb865fd$var$throwError(state, 'duplication of a tag property');
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = '!!';
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = '!';
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else $768caab3beb865fd$var$throwError(state, 'unexpected end of the stream within a verbatim tag');
    } else {
        while(ch !== 0 && !$768caab3beb865fd$var$is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!$768caab3beb865fd$var$PATTERN_TAG_HANDLE.test(tagHandle)) $768caab3beb865fd$var$throwError(state, 'named tag handle cannot contain such characters');
                    isNamed = true;
                    _position = state.position + 1;
                } else $768caab3beb865fd$var$throwError(state, 'tag suffix cannot contain exclamation marks');
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if ($768caab3beb865fd$var$PATTERN_FLOW_INDICATORS.test(tagName)) $768caab3beb865fd$var$throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
    if (tagName && !$768caab3beb865fd$var$PATTERN_TAG_URI.test(tagName)) $768caab3beb865fd$var$throwError(state, 'tag name cannot contain such characters: ' + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        $768caab3beb865fd$var$throwError(state, 'tag name is malformed: ' + tagName);
    }
    if (isVerbatim) state.tag = tagName;
    else if ($768caab3beb865fd$var$_hasOwnProperty$1.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === '!') state.tag = '!' + tagName;
    else if (tagHandle === '!!') state.tag = 'tag:yaml.org,2002:' + tagName;
    else $768caab3beb865fd$var$throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function $768caab3beb865fd$var$readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) $768caab3beb865fd$var$throwError(state, 'duplication of an anchor property');
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$768caab3beb865fd$var$is_WS_OR_EOL(ch) && !$768caab3beb865fd$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $768caab3beb865fd$var$throwError(state, 'name of an anchor node must contain at least one character');
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function $768caab3beb865fd$var$readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$768caab3beb865fd$var$is_WS_OR_EOL(ch) && !$768caab3beb865fd$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $768caab3beb865fd$var$throwError(state, 'name of an alias node must contain at least one character');
    alias = state.input.slice(_position, state.position);
    if (!$768caab3beb865fd$var$_hasOwnProperty$1.call(state.anchorMap, alias)) $768caab3beb865fd$var$throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
    return true;
}
function $768caab3beb865fd$var$composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener('open', state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = $768caab3beb865fd$var$CONTEXT_BLOCK_OUT === nodeContext || $768caab3beb865fd$var$CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if ($768caab3beb865fd$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while($768caab3beb865fd$var$readTagProperty(state) || $768caab3beb865fd$var$readAnchorProperty(state))if ($768caab3beb865fd$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || $768caab3beb865fd$var$CONTEXT_BLOCK_OUT === nodeContext) {
        if ($768caab3beb865fd$var$CONTEXT_FLOW_IN === nodeContext || $768caab3beb865fd$var$CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && ($768caab3beb865fd$var$readBlockSequence(state, blockIndent) || $768caab3beb865fd$var$readBlockMapping(state, blockIndent, flowIndent)) || $768caab3beb865fd$var$readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && $768caab3beb865fd$var$readBlockScalar(state, flowIndent) || $768caab3beb865fd$var$readSingleQuotedScalar(state, flowIndent) || $768caab3beb865fd$var$readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if ($768caab3beb865fd$var$readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) $768caab3beb865fd$var$throwError(state, 'alias node should not have any properties');
                } else if ($768caab3beb865fd$var$readPlainScalar(state, flowIndent, $768caab3beb865fd$var$CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = '?';
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && $768caab3beb865fd$var$readBlockSequence(state, blockIndent);
    }
    if (state.tag === null) {
        if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
    } else if (state.tag === '?') {
        // Implicit resolving is not allowed for non-scalar types, and '?'
        // non-specific tag is only automatically assigned to plain scalars.
        //
        // We only need to check kind conformity in case user explicitly assigns '?'
        // tag, for example like this: "!<?> [0]"
        //
        if (state.result !== null && state.kind !== 'scalar') $768caab3beb865fd$var$throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
        for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type = state.implicitTypes[typeIndex];
            if (type.resolve(state.result)) {
                state.result = type.construct(state.result);
                state.tag = type.tag;
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                break;
            }
        }
    } else if (state.tag !== '!') {
        if ($768caab3beb865fd$var$_hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)) type = state.typeMap[state.kind || 'fallback'][state.tag];
        else {
            // looking for multi type
            type = null;
            typeList = state.typeMap.multi[state.kind || 'fallback'];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type = typeList[typeIndex];
                break;
            }
        }
        if (!type) $768caab3beb865fd$var$throwError(state, 'unknown tag !<' + state.tag + '>');
        if (state.result !== null && type.kind !== state.kind) $768caab3beb865fd$var$throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
        if (!type.resolve(state.result, state.tag)) $768caab3beb865fd$var$throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
        else {
            state.result = type.construct(state.result, state.tag);
            if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
        }
    }
    if (state.listener !== null) state.listener('close', state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function $768caab3beb865fd$var$readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = Object.create(null);
    state.anchorMap = Object.create(null);
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !$768caab3beb865fd$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) $768caab3beb865fd$var$throwError(state, 'directive name must not be less than one character in length');
        while(ch !== 0){
            while($768caab3beb865fd$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !$768caab3beb865fd$var$is_EOL(ch));
                break;
            }
            if ($768caab3beb865fd$var$is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !$768caab3beb865fd$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) $768caab3beb865fd$var$readLineBreak(state);
        if ($768caab3beb865fd$var$_hasOwnProperty$1.call($768caab3beb865fd$var$directiveHandlers, directiveName)) $768caab3beb865fd$var$directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else $768caab3beb865fd$var$throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) $768caab3beb865fd$var$throwError(state, 'directives end mark is expected');
    $768caab3beb865fd$var$composeNode(state, state.lineIndent - 1, $768caab3beb865fd$var$CONTEXT_BLOCK_OUT, false, true);
    $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && $768caab3beb865fd$var$PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) $768caab3beb865fd$var$throwWarning(state, 'non-ASCII line breaks are interpreted as content');
    state.documents.push(state.result);
    if (state.position === state.lineStart && $768caab3beb865fd$var$testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            $768caab3beb865fd$var$skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) $768caab3beb865fd$var$throwError(state, 'end of the stream or a document separator is expected');
    else return;
}
function $768caab3beb865fd$var$loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += '\n';
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new $768caab3beb865fd$var$State$1(input, options);
    var nullpos = input.indexOf('\0');
    if (nullpos !== -1) {
        state.position = nullpos;
        $768caab3beb865fd$var$throwError(state, 'null byte is not allowed in input');
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += '\0';
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)$768caab3beb865fd$var$readDocument(state);
    return state.documents;
}
function $768caab3beb865fd$var$loadAll$1(input, iterator, options) {
    if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    var documents = $768caab3beb865fd$var$loadDocuments(input, options);
    if (typeof iterator !== 'function') return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function $768caab3beb865fd$var$load$1(input, options) {
    var documents = $768caab3beb865fd$var$loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new $768caab3beb865fd$var$exception('expected a single document in the stream, but found more');
}
var $768caab3beb865fd$var$loadAll_1 = $768caab3beb865fd$var$loadAll$1;
var $768caab3beb865fd$var$load_1 = $768caab3beb865fd$var$load$1;
var $768caab3beb865fd$var$loader = {
    loadAll: $768caab3beb865fd$var$loadAll_1,
    load: $768caab3beb865fd$var$load_1
};
/*eslint-disable no-use-before-define*/ var $768caab3beb865fd$var$_toString = Object.prototype.toString;
var $768caab3beb865fd$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
var $768caab3beb865fd$var$CHAR_BOM = 0xFEFF;
var $768caab3beb865fd$var$CHAR_TAB = 0x09; /* Tab */ 
var $768caab3beb865fd$var$CHAR_LINE_FEED = 0x0A; /* LF */ 
var $768caab3beb865fd$var$CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var $768caab3beb865fd$var$CHAR_SPACE = 0x20; /* Space */ 
var $768caab3beb865fd$var$CHAR_EXCLAMATION = 0x21; /* ! */ 
var $768caab3beb865fd$var$CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var $768caab3beb865fd$var$CHAR_SHARP = 0x23; /* # */ 
var $768caab3beb865fd$var$CHAR_PERCENT = 0x25; /* % */ 
var $768caab3beb865fd$var$CHAR_AMPERSAND = 0x26; /* & */ 
var $768caab3beb865fd$var$CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var $768caab3beb865fd$var$CHAR_ASTERISK = 0x2A; /* * */ 
var $768caab3beb865fd$var$CHAR_COMMA = 0x2C; /* , */ 
var $768caab3beb865fd$var$CHAR_MINUS = 0x2D; /* - */ 
var $768caab3beb865fd$var$CHAR_COLON = 0x3A; /* : */ 
var $768caab3beb865fd$var$CHAR_EQUALS = 0x3D; /* = */ 
var $768caab3beb865fd$var$CHAR_GREATER_THAN = 0x3E; /* > */ 
var $768caab3beb865fd$var$CHAR_QUESTION = 0x3F; /* ? */ 
var $768caab3beb865fd$var$CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var $768caab3beb865fd$var$CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var $768caab3beb865fd$var$CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var $768caab3beb865fd$var$CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var $768caab3beb865fd$var$CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var $768caab3beb865fd$var$CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var $768caab3beb865fd$var$CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var $768caab3beb865fd$var$ESCAPE_SEQUENCES = {};
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x00] = '\\0';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x07] = '\\a';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x08] = '\\b';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x09] = '\\t';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x0A] = '\\n';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x0B] = '\\v';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x0C] = '\\f';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x0D] = '\\r';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x1B] = '\\e';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x22] = '\\"';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x5C] = '\\\\';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x85] = '\\N';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0xA0] = '\\_';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x2028] = '\\L';
$768caab3beb865fd$var$ESCAPE_SEQUENCES[0x2029] = '\\P';
var $768caab3beb865fd$var$DEPRECATED_BOOLEANS_SYNTAX = [
    'y',
    'Y',
    'yes',
    'Yes',
    'YES',
    'on',
    'On',
    'ON',
    'n',
    'N',
    'no',
    'No',
    'NO',
    'off',
    'Off',
    'OFF'
];
var $768caab3beb865fd$var$DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
function $768caab3beb865fd$var$compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === '!!') tag = 'tag:yaml.org,2002:' + tag.slice(2);
        type = schema.compiledTypeMap['fallback'][tag];
        if (type && $768caab3beb865fd$var$_hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function $768caab3beb865fd$var$encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = 'x';
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = 'u';
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = 'U';
        length = 8;
    } else throw new $768caab3beb865fd$var$exception('code point within a string may not be greater than 0xFFFFFFFF');
    return '\\' + handle + $768caab3beb865fd$var$common.repeat('0', length - string.length) + string;
}
var $768caab3beb865fd$var$QUOTING_TYPE_SINGLE = 1, $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE = 2;
function $768caab3beb865fd$var$State(options) {
    this.schema = options['schema'] || $768caab3beb865fd$var$_default;
    this.indent = Math.max(1, options['indent'] || 2);
    this.noArrayIndent = options['noArrayIndent'] || false;
    this.skipInvalid = options['skipInvalid'] || false;
    this.flowLevel = $768caab3beb865fd$var$common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
    this.styleMap = $768caab3beb865fd$var$compileStyleMap(this.schema, options['styles'] || null);
    this.sortKeys = options['sortKeys'] || false;
    this.lineWidth = options['lineWidth'] || 80;
    this.noRefs = options['noRefs'] || false;
    this.noCompatMode = options['noCompatMode'] || false;
    this.condenseFlow = options['condenseFlow'] || false;
    this.quotingType = options['quotingType'] === '"' ? $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE : $768caab3beb865fd$var$QUOTING_TYPE_SINGLE;
    this.forceQuotes = options['forceQuotes'] || false;
    this.replacer = typeof options['replacer'] === 'function' ? options['replacer'] : null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = '';
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function $768caab3beb865fd$var$indentString(string, spaces) {
    var ind = $768caab3beb865fd$var$common.repeat(' ', spaces), position = 0, next = -1, result = '', line, length = string.length;
    while(position < length){
        next = string.indexOf('\n', position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== '\n') result += ind;
        result += line;
    }
    return result;
}
function $768caab3beb865fd$var$generateNextLine(state, level) {
    return '\n' + $768caab3beb865fd$var$common.repeat(' ', state.indent * level);
}
function $768caab3beb865fd$var$testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function $768caab3beb865fd$var$isWhitespace(c) {
    return c === $768caab3beb865fd$var$CHAR_SPACE || c === $768caab3beb865fd$var$CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function $768caab3beb865fd$var$isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== $768caab3beb865fd$var$CHAR_BOM || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// Including s-white (for some reason, examples doesn't match specs in this aspect)
// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
function $768caab3beb865fd$var$isNsCharOrWhitespace(c) {
    return $768caab3beb865fd$var$isPrintable(c) && c !== $768caab3beb865fd$var$CHAR_BOM && c !== $768caab3beb865fd$var$CHAR_CARRIAGE_RETURN && c !== $768caab3beb865fd$var$CHAR_LINE_FEED;
}
// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
//                             c = flow-in   ⇒ ns-plain-safe-in
//                             c = block-key ⇒ ns-plain-safe-out
//                             c = flow-key  ⇒ ns-plain-safe-in
// [128] ns-plain-safe-out ::= ns-char
// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
//                            | ( /* An ns-char preceding */ “#” )
//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
function $768caab3beb865fd$var$isPlainSafe(c, prev, inblock) {
    var cIsNsCharOrWhitespace = $768caab3beb865fd$var$isNsCharOrWhitespace(c);
    var cIsNsChar = cIsNsCharOrWhitespace && !$768caab3beb865fd$var$isWhitespace(c);
    return(// ns-plain-safe
    (inblock ? cIsNsCharOrWhitespace : cIsNsCharOrWhitespace && c !== $768caab3beb865fd$var$CHAR_COMMA && c !== $768caab3beb865fd$var$CHAR_LEFT_SQUARE_BRACKET && c !== $768caab3beb865fd$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $768caab3beb865fd$var$CHAR_LEFT_CURLY_BRACKET && c !== $768caab3beb865fd$var$CHAR_RIGHT_CURLY_BRACKET) && c !== $768caab3beb865fd$var$CHAR_SHARP // false on '#'
     && !(prev === $768caab3beb865fd$var$CHAR_COLON && !cIsNsChar // false on ': '
    ) || $768caab3beb865fd$var$isNsCharOrWhitespace(prev) && !$768caab3beb865fd$var$isWhitespace(prev) && c === $768caab3beb865fd$var$CHAR_SHARP // change to true on '[^ ]#'
     || prev === $768caab3beb865fd$var$CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
}
// Simplified test for values allowed as the first character in plain style.
function $768caab3beb865fd$var$isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
    return $768caab3beb865fd$var$isPrintable(c) && c !== $768caab3beb865fd$var$CHAR_BOM && !$768caab3beb865fd$var$isWhitespace(c) // - s-white
     && c !== $768caab3beb865fd$var$CHAR_MINUS && c !== $768caab3beb865fd$var$CHAR_QUESTION && c !== $768caab3beb865fd$var$CHAR_COLON && c !== $768caab3beb865fd$var$CHAR_COMMA && c !== $768caab3beb865fd$var$CHAR_LEFT_SQUARE_BRACKET && c !== $768caab3beb865fd$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $768caab3beb865fd$var$CHAR_LEFT_CURLY_BRACKET && c !== $768caab3beb865fd$var$CHAR_RIGHT_CURLY_BRACKET && c !== $768caab3beb865fd$var$CHAR_SHARP && c !== $768caab3beb865fd$var$CHAR_AMPERSAND && c !== $768caab3beb865fd$var$CHAR_ASTERISK && c !== $768caab3beb865fd$var$CHAR_EXCLAMATION && c !== $768caab3beb865fd$var$CHAR_VERTICAL_LINE && c !== $768caab3beb865fd$var$CHAR_EQUALS && c !== $768caab3beb865fd$var$CHAR_GREATER_THAN && c !== $768caab3beb865fd$var$CHAR_SINGLE_QUOTE && c !== $768caab3beb865fd$var$CHAR_DOUBLE_QUOTE && c !== $768caab3beb865fd$var$CHAR_PERCENT && c !== $768caab3beb865fd$var$CHAR_COMMERCIAL_AT && c !== $768caab3beb865fd$var$CHAR_GRAVE_ACCENT;
}
// Simplified test for values allowed as the last character in plain style.
function $768caab3beb865fd$var$isPlainSafeLast(c) {
    // just not whitespace or colon, it will be checked to be plain character later
    return !$768caab3beb865fd$var$isWhitespace(c) && c !== $768caab3beb865fd$var$CHAR_COLON;
}
// Same as 'string'.codePointAt(pos), but works in older browsers.
function $768caab3beb865fd$var$codePointAt(string, pos) {
    var first = string.charCodeAt(pos), second;
    if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
        second = string.charCodeAt(pos + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
// Determines whether block indentation indicator is required.
function $768caab3beb865fd$var$needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var $768caab3beb865fd$var$STYLE_PLAIN = 1, $768caab3beb865fd$var$STYLE_SINGLE = 2, $768caab3beb865fd$var$STYLE_LITERAL = 3, $768caab3beb865fd$var$STYLE_FOLDED = 4, $768caab3beb865fd$var$STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function $768caab3beb865fd$var$chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType, quotingType, forceQuotes, inblock) {
    var i;
    var char = 0;
    var prevChar = null;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = $768caab3beb865fd$var$isPlainSafeFirst($768caab3beb865fd$var$codePointAt(string, 0)) && $768caab3beb865fd$var$isPlainSafeLast($768caab3beb865fd$var$codePointAt(string, string.length - 1));
    if (singleLineOnly || forceQuotes) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $768caab3beb865fd$var$codePointAt(string, i);
        if (!$768caab3beb865fd$var$isPrintable(char)) return $768caab3beb865fd$var$STYLE_DOUBLE;
        plain = plain && $768caab3beb865fd$var$isPlainSafe(char, prevChar, inblock);
        prevChar = char;
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
            char = $768caab3beb865fd$var$codePointAt(string, i);
            if (char === $768caab3beb865fd$var$CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
                    previousLineBreak = i;
                }
            } else if (!$768caab3beb865fd$var$isPrintable(char)) return $768caab3beb865fd$var$STYLE_DOUBLE;
            plain = plain && $768caab3beb865fd$var$isPlainSafe(char, prevChar, inblock);
            prevChar = char;
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) {
        // Strings interpretable as another type have to be quoted;
        // e.g. the string 'true' vs. the boolean true.
        if (plain && !forceQuotes && !testAmbiguousType(string)) return $768caab3beb865fd$var$STYLE_PLAIN;
        return quotingType === $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE ? $768caab3beb865fd$var$STYLE_DOUBLE : $768caab3beb865fd$var$STYLE_SINGLE;
    }
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && $768caab3beb865fd$var$needIndentIndicator(string)) return $768caab3beb865fd$var$STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    if (!forceQuotes) return hasFoldableLine ? $768caab3beb865fd$var$STYLE_FOLDED : $768caab3beb865fd$var$STYLE_LITERAL;
    return quotingType === $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE ? $768caab3beb865fd$var$STYLE_DOUBLE : $768caab3beb865fd$var$STYLE_SINGLE;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function $768caab3beb865fd$var$writeScalar(state, string, level, iskey, inblock) {
    state.dump = function() {
        if (string.length === 0) return state.quotingType === $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE ? '""' : "''";
        if (!state.noCompatMode) {
            if ($768caab3beb865fd$var$DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || $768caab3beb865fd$var$DEPRECATED_BASE60_SYNTAX.test(string)) return state.quotingType === $768caab3beb865fd$var$QUOTING_TYPE_DOUBLE ? '"' + string + '"' : "'" + string + "'";
        }
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return $768caab3beb865fd$var$testImplicitResolving(state, string);
        }
        switch($768caab3beb865fd$var$chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)){
            case $768caab3beb865fd$var$STYLE_PLAIN:
                return string;
            case $768caab3beb865fd$var$STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case $768caab3beb865fd$var$STYLE_LITERAL:
                return '|' + $768caab3beb865fd$var$blockHeader(string, state.indent) + $768caab3beb865fd$var$dropEndingNewline($768caab3beb865fd$var$indentString(string, indent));
            case $768caab3beb865fd$var$STYLE_FOLDED:
                return '>' + $768caab3beb865fd$var$blockHeader(string, state.indent) + $768caab3beb865fd$var$dropEndingNewline($768caab3beb865fd$var$indentString($768caab3beb865fd$var$foldString(string, lineWidth), indent));
            case $768caab3beb865fd$var$STYLE_DOUBLE:
                return '"' + $768caab3beb865fd$var$escapeString(string) + '"';
            default:
                throw new $768caab3beb865fd$var$exception('impossible error: invalid scalar style');
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function $768caab3beb865fd$var$blockHeader(string, indentPerLevel) {
    var indentIndicator = $768caab3beb865fd$var$needIndentIndicator(string) ? String(indentPerLevel) : '';
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === '\n';
    var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
    var chomp = keep ? '+' : clip ? '' : '-';
    return indentIndicator + chomp + '\n';
}
// (See the note for writeScalar.)
function $768caab3beb865fd$var$dropEndingNewline(string) {
    return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function $768caab3beb865fd$var$foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf('\n');
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return $768caab3beb865fd$var$foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === ' ';
        result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + $768caab3beb865fd$var$foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function $768caab3beb865fd$var$foldLine(line, width) {
    if (line === '' || line[0] === ' ') return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = '';
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += '\n' + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += '\n';
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function $768caab3beb865fd$var$escapeString(string) {
    var result = '';
    var char = 0;
    var escapeSeq;
    for(var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $768caab3beb865fd$var$codePointAt(string, i);
        escapeSeq = $768caab3beb865fd$var$ESCAPE_SEQUENCES[char];
        if (!escapeSeq && $768caab3beb865fd$var$isPrintable(char)) {
            result += string[i];
            if (char >= 0x10000) result += string[i + 1];
        } else result += escapeSeq || $768caab3beb865fd$var$encodeHex(char);
    }
    return result;
}
function $768caab3beb865fd$var$writeFlowSequence(state, level, object) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($768caab3beb865fd$var$writeNode(state, level, value, false, false) || typeof value === 'undefined' && $768caab3beb865fd$var$writeNode(state, level, null, false, false)) {
            if (_result !== '') _result += ',' + (!state.condenseFlow ? ' ' : '');
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = '[' + _result + ']';
}
function $768caab3beb865fd$var$writeBlockSequence(state, level, object, compact) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($768caab3beb865fd$var$writeNode(state, level + 1, value, true, true, false, true) || typeof value === 'undefined' && $768caab3beb865fd$var$writeNode(state, level + 1, null, true, true, false, true)) {
            if (!compact || _result !== '') _result += $768caab3beb865fd$var$generateNextLine(state, level);
            if (state.dump && $768caab3beb865fd$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += '-';
            else _result += '- ';
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = _result || '[]'; // Empty sequence if no valid values.
}
function $768caab3beb865fd$var$writeFlowMapping(state, level, object) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (_result !== '') pairBuffer += ', ';
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$768caab3beb865fd$var$writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += '? ';
        pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
        if (!$768caab3beb865fd$var$writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = '{' + _result + '}';
}
function $768caab3beb865fd$var$writeBlockMapping(state, level, object, compact) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === 'function') // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new $768caab3beb865fd$var$exception('sortKeys must be a boolean or a function');
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (!compact || _result !== '') pairBuffer += $768caab3beb865fd$var$generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$768caab3beb865fd$var$writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && $768caab3beb865fd$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += '?';
            else pairBuffer += '? ';
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += $768caab3beb865fd$var$generateNextLine(state, level);
        if (!$768caab3beb865fd$var$writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && $768caab3beb865fd$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ':';
        else pairBuffer += ': ';
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}
function $768caab3beb865fd$var$detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            if (explicit) {
                if (type.multi && type.representName) state.tag = type.representName(object);
                else state.tag = type.tag;
            } else state.tag = '?';
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if ($768caab3beb865fd$var$_toString.call(type.represent) === '[object Function]') _result = type.represent(object, style);
                else if ($768caab3beb865fd$var$_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new $768caab3beb865fd$var$exception('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function $768caab3beb865fd$var$writeNode(state, level, object, block, compact, iskey, isblockseq) {
    state.tag = null;
    state.dump = object;
    if (!$768caab3beb865fd$var$detectType(state, object, false)) $768caab3beb865fd$var$detectType(state, object, true);
    var type = $768caab3beb865fd$var$_toString.call(state.dump);
    var inblock = block;
    var tagStr;
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === '[object Object]' || type === '[object Array]', duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = '*ref_' + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === '[object Object]') {
            if (block && Object.keys(state.dump).length !== 0) {
                $768caab3beb865fd$var$writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $768caab3beb865fd$var$writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object Array]') {
            if (block && state.dump.length !== 0) {
                if (state.noArrayIndent && !isblockseq && level > 0) $768caab3beb865fd$var$writeBlockSequence(state, level - 1, state.dump, compact);
                else $768caab3beb865fd$var$writeBlockSequence(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $768caab3beb865fd$var$writeFlowSequence(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object String]') {
            if (state.tag !== '?') $768caab3beb865fd$var$writeScalar(state, state.dump, level, iskey, inblock);
        } else if (type === '[object Undefined]') return false;
        else {
            if (state.skipInvalid) return false;
            throw new $768caab3beb865fd$var$exception('unacceptable kind of an object to dump ' + type);
        }
        if (state.tag !== null && state.tag !== '?') {
            // Need to encode all characters except those allowed by the spec:
            //
            // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
            // [36] ns-hex-digit    ::=  ns-dec-digit
            //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
            // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
            // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
            // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
            //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
            //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
            //
            // Also need to encode '!' because it has special meaning (end of tag prefix).
            //
            tagStr = encodeURI(state.tag[0] === '!' ? state.tag.slice(1) : state.tag).replace(/!/g, '%21');
            if (state.tag[0] === '!') tagStr = '!' + tagStr;
            else if (tagStr.slice(0, 18) === 'tag:yaml.org,2002:') tagStr = '!!' + tagStr.slice(18);
            else tagStr = '!<' + tagStr + '>';
            state.dump = tagStr + ' ' + state.dump;
        }
    }
    return true;
}
function $768caab3beb865fd$var$getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    $768caab3beb865fd$var$inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function $768caab3beb865fd$var$inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === 'object') {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)$768caab3beb865fd$var$inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)$768caab3beb865fd$var$inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function $768caab3beb865fd$var$dump$1(input, options) {
    options = options || {};
    var state = new $768caab3beb865fd$var$State(options);
    if (!state.noRefs) $768caab3beb865fd$var$getDuplicateReferences(input, state);
    var value = input;
    if (state.replacer) value = state.replacer.call({
        '': value
    }, '', value);
    if ($768caab3beb865fd$var$writeNode(state, 0, value, true, true)) return state.dump + '\n';
    return '';
}
var $768caab3beb865fd$var$dump_1 = $768caab3beb865fd$var$dump$1;
var $768caab3beb865fd$var$dumper = {
    dump: $768caab3beb865fd$var$dump_1
};
function $768caab3beb865fd$var$renamed(from, to) {
    return function() {
        throw new Error('Function yaml.' + from + ' is removed in js-yaml 4. ' + 'Use yaml.' + to + ' instead, which is now safe by default.');
    };
}
var $768caab3beb865fd$export$92738401e1603719 = $768caab3beb865fd$var$type;
var $768caab3beb865fd$export$19342e026b58ebb7 = $768caab3beb865fd$var$schema;
var $768caab3beb865fd$export$aefe34bace55c48e = $768caab3beb865fd$var$failsafe;
var $768caab3beb865fd$export$3f5573a59aee743 = $768caab3beb865fd$var$json;
var $768caab3beb865fd$export$cb27b7e9f9bc8fa8 = $768caab3beb865fd$var$core;
var $768caab3beb865fd$export$54192bc17d2d9e2a = $768caab3beb865fd$var$_default;
var $768caab3beb865fd$export$11e63f7b0f3d9900 = $768caab3beb865fd$var$loader.load;
var $768caab3beb865fd$export$7aabae09a30b04c2 = $768caab3beb865fd$var$loader.loadAll;
var $768caab3beb865fd$export$2069a8a5a76faa2 = $768caab3beb865fd$var$dumper.dump;
var $768caab3beb865fd$export$28af3d4da69ed747 = $768caab3beb865fd$var$exception;
// Re-export all types in case user wants to create custom schema
var $768caab3beb865fd$export$b14ad400b1d09e0f = {
    binary: $768caab3beb865fd$var$binary,
    float: $768caab3beb865fd$var$float,
    map: $768caab3beb865fd$var$map,
    null: $768caab3beb865fd$var$_null,
    pairs: $768caab3beb865fd$var$pairs,
    set: $768caab3beb865fd$var$set,
    timestamp: $768caab3beb865fd$var$timestamp,
    bool: $768caab3beb865fd$var$bool,
    int: $768caab3beb865fd$var$int,
    merge: $768caab3beb865fd$var$merge,
    omap: $768caab3beb865fd$var$omap,
    seq: $768caab3beb865fd$var$seq,
    str: $768caab3beb865fd$var$str
};
// Removed functions from JS-YAML 3.0.x
var $768caab3beb865fd$export$ecc08907c0e2af9b = $768caab3beb865fd$var$renamed('safeLoad', 'load');
var $768caab3beb865fd$export$c2cc0f4fb6d29644 = $768caab3beb865fd$var$renamed('safeLoadAll', 'loadAll');
var $768caab3beb865fd$export$befffea07f2abcf0 = $768caab3beb865fd$var$renamed('safeDump', 'dump');
var $768caab3beb865fd$var$jsYaml = {
    Type: $768caab3beb865fd$export$92738401e1603719,
    Schema: $768caab3beb865fd$export$19342e026b58ebb7,
    FAILSAFE_SCHEMA: $768caab3beb865fd$export$aefe34bace55c48e,
    JSON_SCHEMA: $768caab3beb865fd$export$3f5573a59aee743,
    CORE_SCHEMA: $768caab3beb865fd$export$cb27b7e9f9bc8fa8,
    DEFAULT_SCHEMA: $768caab3beb865fd$export$54192bc17d2d9e2a,
    load: $768caab3beb865fd$export$11e63f7b0f3d9900,
    loadAll: $768caab3beb865fd$export$7aabae09a30b04c2,
    dump: $768caab3beb865fd$export$2069a8a5a76faa2,
    YAMLException: $768caab3beb865fd$export$28af3d4da69ed747,
    types: $768caab3beb865fd$export$b14ad400b1d09e0f,
    safeLoad: $768caab3beb865fd$export$ecc08907c0e2af9b,
    safeLoadAll: $768caab3beb865fd$export$c2cc0f4fb6d29644,
    safeDump: $768caab3beb865fd$export$befffea07f2abcf0
};
var $768caab3beb865fd$export$2e2bcd8739ae039 = $768caab3beb865fd$var$jsYaml;


const $4b42aeb6089abef0$export$d118786f359a8bfd = (data, cache)=>{
    let dupes = [];
    let truncatedData = [];
    // Transpose cache
    const cacheByID = {};
    Object.keys(cache).forEach((key)=>{
        const arr = cache[key];
        arr.forEach((id)=>{
            cacheByID[id] = key;
        });
    });
    // Initial pass
    data.forEach((entry)=>{
        let category = entry.category.length > 0 ? entry.category[0].name : 'Other Program';
        if (!dupes.includes(entry.title) && ![
            'cancel',
            'brendan',
            '1-on-1'
        ].some((x)=>entry.title.toLowerCase().includes(x)) && category !== "Holiday") {
            if (entry.allday) dupes.push(entry.title);
            let event = {
                "title": entry.title.replace("Bridgewater-Raritan High School", "BRHS"),
                "date": [
                    new Date(entry.start)
                ].concat(entry.future_dates.map(({ start: start })=>new Date(start))),
                "length": entry.allday ? 24 : (new Date(entry.end) - new Date(entry.start)) / $62d9c6abc6c16b60$export$371ef0f33bdee71f,
                "range": entry.allday && entry.future_dates.length > 2,
                "category": category,
                "image": cacheByID[entry.id],
                "form": entry.url.public
            };
            event.enddate = event.range ? new Date(event.date[event.date.length - 1]) : new Date(entry.end);
            event.schedule = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${$62d9c6abc6c16b60$export$78a7e49ccc71dc8c(event.date[0])}%2F${$62d9c6abc6c16b60$export$78a7e49ccc71dc8c(event.enddate)}&location=Raritan%20Public%20Library&text=${encodeURIComponent(event.title)}`;
            event.datesort = event.date[0] < $62d9c6abc6c16b60$export$461939dd4422153 && event.length === "range" ? $62d9c6abc6c16b60$export$461939dd4422153 : event.date[0];
            truncatedData.push(event);
        }
    });
    truncatedData = truncatedData.sort((a, b)=>a.datesort - b.datesort);
    // Begin injection
    let displayed = 0;
    let eventList = ``;
    for (const event of truncatedData){
        let eventDateTime = $62d9c6abc6c16b60$export$26e685d98fdeb12f(event.date[0]);
        if (displayed === 6) break;
        if (event.range) eventDateTime += ` - ${$62d9c6abc6c16b60$export$26e685d98fdeb12f(event.enddate)}`;
        else if (event.date.length > 1 && event.date[0].getDate() === event.date[1].getDate()) eventDateTime += ` | ${$62d9c6abc6c16b60$export$3203edd9e5edd663(event.date[0])} and ${$62d9c6abc6c16b60$export$3203edd9e5edd663(event.date[1])}`;
        else eventDateTime += ` | ${$62d9c6abc6c16b60$export$3203edd9e5edd663(event.date[0])}`;
        if (event.enddate >= $62d9c6abc6c16b60$export$461939dd4422153 && event.category !== 'Reading Program') {
            eventList += `
            <div class="event">
                <div class="event-category">${event.category}</div>
                <div class="event-main">
                    <picture class="event-image">
                        <img src="img/events/${event.image}.jpg" alt="${event.title}" type="image/jpeg">
                    </picture>
                    <div class="event-info">
                        <h2 class="event-header" href="${event.form}" target="_blank" rel="noopener">${event.title}</h2>
                        <div class="event-datetime">${eventDateTime}</div>
                        <div class="event-action">
                            <a href="${event.form}" target="_blank" rel="noopener">Register</a>
                            <a href="${event.schedule}" target="_blank" rel="noopener">Add to calendar</a>
                        </div>
                    </div>
                </div>
            </div>`;
            displayed++;
        }
    }
    // Check for div
    const upcomingDiv = document.getElementById("upcoming");
    if (upcomingDiv) upcomingDiv.innerHTML = eventList;
};
const $4b42aeb6089abef0$export$20e0353d92eda19d = (events, dateTime)=>{
    const curMonth = dateTime.getMonth();
    const curMonthName = $62d9c6abc6c16b60$export$a038b291f736c35e[curMonth];
    const curYear = dateTime.getFullYear();
    const lastDate = new Date(curYear, curMonth - 1, 1);
    const lastMonth = lastDate.getMonth();
    const lastMonthName = $62d9c6abc6c16b60$export$a038b291f736c35e[lastMonth];
    const lastYear = lastDate.getFullYear();
    const nextDate = new Date(curYear, curMonth + 1, 1);
    const nextMonth = nextDate.getMonth();
    const nextMonthName = $62d9c6abc6c16b60$export$a038b291f736c35e[nextMonth];
    const nextYear = nextDate.getFullYear();
    document.getElementById("calendar-month").innerHTML = `${curMonthName} ${curYear}`;
    document.getElementById("calendar-nav-back").innerHTML = `\u{1F850} ${lastMonthName} ${lastYear}`;
    document.getElementById("calendar-nav-next").innerHTML = `${nextMonthName} ${nextYear} \u{1F852}`;
    // Get day of the week for the first day of the month
    const monthFirst = new Date(curYear, dateTime.getMonth(), 1);
    const monthFirstDay = monthFirst.getDay();
    // Add all days of the month, starting from Sunday
    // Then count from that first day until the calendar is filled
    // Add events as you go through the calendar
    let calDate = new Date(curYear, dateTime.getMonth(), 1 - monthFirstDay);
    let calIter = 0;
    let calContent = ``;
    const simpleNow = new Date($62d9c6abc6c16b60$export$461939dd4422153.getFullYear(), $62d9c6abc6c16b60$export$461939dd4422153.getMonth(), $62d9c6abc6c16b60$export$461939dd4422153.getDate());
    while(!(calIter > 6 && dateTime.getMonth() !== calDate.getMonth() && calDate.getDay() === 0)){
        const filteredEvents = events.filter((event)=>new Date(event.start).setHours(0, 0, 0, 0) === calDate.setHours(0, 0, 0, 0) && ![
                'cancel',
                'brendan',
                '1-on-1'
            ].some((x)=>event.title.toLowerCase().includes(x)));
        const dayClass = dateTime.getMonth() !== calDate.getMonth() ? "-grey" : simpleNow.getTime() === calDate.getTime() ? "-now" : "";
        const hideEmpty = filteredEvents.length === 0 || calDate.getMonth() === simpleNow.getMonth() & calDate.getDate() < simpleNow.getDate() ? " calendar-day-empty" : "";
        calContent += ` 
        <div class="calendar-day${dayClass}${hideEmpty}">
            <div class="calendar-num">
                <span class="calendar-num-dotw">${$62d9c6abc6c16b60$export$b7f7efbe9ab39b25(calDate)}</span>
                <span class="calendar-num-date"><span class="calendar-num-date-month">${$62d9c6abc6c16b60$export$a038b291f736c35e[calDate.getMonth()]}</span> ${calDate.getDate()}</span>
            </div>`;
        for (const event of filteredEvents){
            let eventTitle = event.title;
            let eventTime = event.allday ? "All Day Event" : `${$62d9c6abc6c16b60$export$3203edd9e5edd663(new Date(event.start))} - ${$62d9c6abc6c16b60$export$3203edd9e5edd663(new Date(event.end))}`;
            calContent += `
            <a class="calendar-entry-${$b3578e6e7db5838b$export$3ae65339208f6100(event.category)}" href="${event.url.public}" target="_blank" rel="noopener">
                <span class="calendar-entry-${$b3578e6e7db5838b$export$3ae65339208f6100(event.category)}-time">${eventTime}</span>
                <span>${eventTitle}</span>
            </a>`;
        }
        calContent += `</div>`;
        calDate = new Date(calDate.getFullYear(), calDate.getMonth(), calDate.getDate() + 1);
        calIter++;
    }
    document.getElementById("calendar-weeks").innerHTML = calContent;
};
// Git data
let $4b42aeb6089abef0$var$rev = "388\n";
let $4b42aeb6089abef0$var$sha5 = "2d9979ba0459ff0e9e553774e81e8b4a7cb15aa5\n";
const $4b42aeb6089abef0$export$e85a8dcc29475cfa = ()=>{
    document.getElementById("git").innerHTML = `<a href="/site-map">Site Map</a> \xb7 <a href="/privacy"> Privacy</a> \xb7 v2.${String($4b42aeb6089abef0$var$rev - 346).padStart(3, '0')} (${$4b42aeb6089abef0$var$sha5.slice(0, 7)}) `;
};



const $388eee12b32806dc$export$513ccb98c53b8039 = ()=>{
    const root = document.documentElement;
    if (localStorage.getItem("color-mode") === "dark") root.setAttribute("color-mode", "dark");
};
// Toggle light/dark mode
const $388eee12b32806dc$var$toggleMode = (type)=>{
    const root = document.documentElement;
    const themeButton = document.getElementById("theme");
    const all = document.querySelectorAll("* :not(b):not(span):not(i):not(sup):not(path):not(svg)");
    const addRemove = type === "dark" ? "add" : "remove";
    themeButton.classList[addRemove]("darkmodeon");
    all.forEach((element)=>element.style.transition = "all 0.2s ease-in-out");
    root.setAttribute("color-mode", type);
    localStorage.setItem("color-mode", type);
    setTimeout(()=>all.forEach((element)=>element.style.transition = ""), 500);
};
const $388eee12b32806dc$export$f543642fc33c1018 = ()=>{
    const themeButton = document.getElementById("theme");
    if (localStorage.getItem("color-mode") === "dark") themeButton.classList.add("darkmodeon");
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        if (themeButton.contains(e.target) && !themeButton.classList.contains("darkmodeon")) $388eee12b32806dc$var$toggleMode("dark");
        else if (themeButton.contains(e.target) && themeButton.classList.contains("darkmodeon")) $388eee12b32806dc$var$toggleMode("lite");
    });
};
const $388eee12b32806dc$export$dd08b95ed5ec19a6 = ()=>{
    const html = document.documentElement;
    const body = document.body;
    const upButton = document.getElementById("totop");
    // Calc height
    const width = $b3578e6e7db5838b$export$3c49c185de0c2bfc();
    let height = 60;
    if (width > 1368) height = 0;
    else if (width >= 768) height = 84;
    else if (width >= 500) height = 76;
    // Appear when 20% below top
    document.addEventListener('scroll', (e)=>{
        const element = body.scrollHeight - body.clientHeight === 0 ? html : body;
        const maxScroll = element.scrollHeight - element.clientHeight;
        const ratio = element.scrollTop / maxScroll;
        if (maxScroll / element.clientHeight >= 1) {
            if (element.scrollTop >= maxScroll * 0.2 + height * 2) upButton.style.top = `calc(100vh - ${height}px)`;
            else if (ratio >= 0.2) upButton.style.top = `calc(100vh - ${(element.scrollTop - maxScroll * 0.2) / 2}px)`;
            else upButton.style.top = '100vh';
        } else upButton.style.top = '100vh';
    });
    // Scroll to top on click
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        if (upButton.contains(e.target)) {
            html.scrollTop = 0; // chrome/ff/ie/opera
            body.scrollTop = 0; // safari
        }
    });
};



const $27b556cf1e8c5b43$export$124049a9e3d0d4c3 = ()=>{
    // Slide information
    const container = document.getElementById('hero-content');
    let slides = Array.from(container.children);
    const dots = Array.from(document.getElementById('hero-select').children);
    const maxSlide = slides.length - 1;
    const firstSlide = slides[0];
    const lastSlide = slides[maxSlide];
    const cloneFirst = firstSlide.cloneNode(true);
    const cloneLast = lastSlide.cloneNode(true);
    let curSlide = 0;
    let curSlideMod = 0;
    let allowShift = true;
    let autoAdvance = true;
    const prev = document.getElementById("hero-prev");
    const next = document.getElementById("hero-next");
    // Clone first/last slides
    container.appendChild(cloneFirst);
    container.insertBefore(cloneLast, firstSlide);
    slides = Array.from(container.children);
    slides.forEach((slide)=>slide.style.transform = `translateX(-100%)`);
    // Wait for transition
    const transitionEndSelector = ()=>{
        const e = document.createElement('fakeelement');
        const transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };
        for(let t in transitions){
            if (e.style[t] !== undefined) return transitions[t];
        }
    };
    const transitionEnd = transitionEndSelector();
    // Shift logic
    const shift = (n)=>{
        // Add transition
        slides.forEach((slide)=>slide.classList.add('shift'));
        // Unset slide dot
        document.getElementById(`hero-dot-${curSlide}`).classList.remove('hero-select-current');
        // Advance slide
        curSlide = curSlide + n;
        curSlideMod = $b3578e6e7db5838b$export$842a2cf37af977e1(curSlide, maxSlide + 1);
        slides.forEach((slide)=>slide.style.transform = `translateX(${-100 * (curSlide + 1)}%)`);
        // Set slide dot
        document.getElementById(`hero-dot-${curSlideMod}`).classList.add('hero-select-current');
        // Check to allow shifting
        allowShift = curSlide === curSlideMod;
    };
    // Remove transition after finish, account for edge slides
    const checkIndex = ()=>{
        slides.forEach((slide)=>slide.classList.remove('shift'));
        if (curSlide === -1) {
            slides.forEach((slide)=>slide.style.transform = `translateX(${-100 * maxSlide - 100}%)`);
            curSlide = maxSlide;
        } else if (curSlide === maxSlide + 1) {
            slides.forEach((slide)=>slide.style.transform = `translateX(-100%)`);
            curSlide = 0;
        }
        allowShift = true;
    };
    // Navigation listeners
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        // Arrows
        if (prev.contains(e.target) && allowShift) {
            autoAdvance = false;
            shift(-1);
        } else if (next.contains(e.target) && allowShift) {
            autoAdvance = false;
            shift(1);
        }
        // Dots
        dots.forEach((dot, i)=>{
            if (dot.contains(e.target) && allowShift) {
                autoAdvance = false;
                shift(i - curSlide);
            }
        });
    });
    // Transition listeners
    slides.forEach((slide)=>slide.addEventListener(transitionEnd, checkIndex));
    // Auto-advance until clicked
    setInterval(()=>{
        if (autoAdvance) shift(1);
    }, 8500);
};




const $6ebf28e7af071060$var$_biJson = '{\r\n    "1": {"name": "Joe Abercrombie"},\r\n    "2": {"name": "Elizabeth Adler"},\r\n    "3": {"name": "Susan Wittig Albert"},\r\n    "4": {"name": "Mitch Albom"},\r\n    "5": {"name": "Isabel Allende"},\r\n    "6": {"name": "Mary Kay Andrews"},\r\n    "7": {"name": "Jeffrey Archer"},\r\n    "8": {"name": "Ace Atkins"},\r\n    "9": {"name": "Kate Atkinson"},\r\n    "10": {"name": "Margaret Atwood"},\r\n    "11": {"name": "Fredrik Backman"},\r\n    "12": {"name": "David Baldacci"},\r\n    "13": {"name": "Mary Balough"},\r\n    "14": {"name": "Leigh Bardugo"},\r\n    "15": {"name": "Nevada Barr"},\r\n    "16": {"name": "M. C. Beaton"},\r\n    "17": {"name": "Alex Berenson"},\r\n    "18": {"name": "Elizabeth Berg"},\r\n    "19": {"name": "Steve Berry"},\r\n    "20": {"name": "Chris Bohjalian"},\r\n    "21": {"name": "Rhys Bowen"},\r\n    "22": {"name": "C. J. Box"},\r\n    "23": {"name": "Barbara Bradford"},\r\n    "24": {"name": "Geraldine Brooks"},\r\n    "25": {"name": "Terry Brooks"},\r\n    "26": {"name": "Dale Brown"},\r\n    "27": {"name": "Dan Brown"},\r\n    "28": {"name": "Rita Mae Brown"},\r\n    "29": {"name": "Sandra Brown"},\r\n    "30": {"name": "Alafair Burke"},\r\n    "31": {"name": "James Lee Burke"},\r\n    "32": {"name": "Jim Butcher"},\r\n    "33": {"name": "Meg Cabot"},\r\n    "34": {"name": "Orson Scott Card"},\r\n    "35": {"name": "Robyn Carr"},\r\n    "36": {"name": "Linda Castillo"},\r\n    "37": {"name": "Michael Chabon"},\r\n    "38": {"name": "Diane Chamberlain"},\r\n    "39": {"name": "Tracy Chevalier"},\r\n    "40": {"name": "Jennifer Chiaverini"},\r\n    "41": {"name": "Lee Child"},\r\n    "42": {"name": "Lincoln Child"},\r\n    "43": {"name": "Laura Childs"},\r\n    "44": {"name": "Carol Higgins Clark"},\r\n    "45": {"name": "Mary Jane Clark"},\r\n    "46": {"name": "Harlan Coben"},\r\n    "47": {"name": "Michael Connelly"},\r\n    "48": {"name": "John Connolly"},\r\n    "49": {"name": "Robin Cook"},\r\n    "50": {"name": "James S. A. Corey"},\r\n    "51": {"name": "Bernard Cornwell"},\r\n    "52": {"name": "Patricia Cornwell"},\r\n    "53": {"name": "Catherine Coulter"},\r\n    "54": {"name": "Robert Crais"},\r\n    "55": {"name": "Blake Crouch"},\r\n    "56": {"name": "Clive Cussler"},\r\n    "57": {"name": "Janet Dailey"},\r\n    "58": {"name": "Jeffery Deaver"},\r\n    "59": {"name": "Ted Dekker"},\r\n    "60": {"name": "Barbara Delinsky"},\r\n    "61": {"name": "Nelson Demille"},\r\n    "62": {"name": "Jude Deveraux"},\r\n    "63": {"name": "Anita Diamant"},\r\n    "64": {"name": "Louise Erdrich"},\r\n    "65": {"name": "Janet Evanovich"},\r\n    "66": {"name": "Richard Paul Evans"},\r\n    "67": {"name": "Linda Fairstein"},\r\n    "68": {"name": "Christine Feehan"},\r\n    "69": {"name": "Joy Fielding"},\r\n    "70": {"name": "Fannie Flagg"},\r\n    "71": {"name": "Joanne Fluke"},\r\n    "72": {"name": "Gillian Flynn"},\r\n    "73": {"name": "Vince Flynn"},\r\n    "74": {"name": "Ken Follett"},\r\n    "75": {"name": "Tana French"},\r\n    "76": {"name": "Diana Gabaldon"},\r\n    "77": {"name": "Neil Gaiman"},\r\n    "78": {"name": "Robert Galbraith"},\r\n    "79": {"name": "Lisa Gardner"},\r\n    "80": {"name": "Julie Garwood"},\r\n    "81": {"name": "Elizabeth George"},\r\n    "82": {"name": "Tess Gerritsen"},\r\n    "83": {"name": "Emily Giffin"},\r\n    "84": {"name": "Heather Graham"},\r\n    "85": {"name": "Jane Green"},\r\n    "86": {"name": "Philippa Gregory"},\r\n    "87": {"name": "W. E. B. Griffin"},\r\n    "88": {"name": "Martha Grimes"},\r\n    "89": {"name": "James Grippando"},\r\n    "90": {"name": "John Grisham"},\r\n    "91": {"name": "Sara Gruen"},\r\n    "92": {"name": "Laurell K. Hamilton"},\r\n    "93": {"name": "Kristin Hannah"},\r\n    "94": {"name": "Charlaine Harris"},\r\n    "95": {"name": "Grady Hendrix"},\r\n    "96": {"name": "Carl Hiaasen"},\r\n    "97": {"name": "Elin Hilderbrand"},\r\n    "98": {"name": "Joe Hill"},\r\n    "99": {"name": "Tami Hoag"},\r\n    "100": {"name": "Alice Hoffman"},\r\n    "101": {"name": "Khaled Hosseini"},\r\n    "102": {"name": "Stephen Hunter"},\r\n    "103": {"name": "Greg Iles"},\r\n    "104": {"name": "John Irving"},\r\n    "105": {"name": "Lisa Jackson"},\r\n    "106": {"name": "J. A. Jance"},\r\n    "107": {"name": "N. K. Jemisin"},\r\n    "108": {"name": "Iris Johansen"},\r\n    "109": {"name": "Craig Johnson"},\r\n    "110": {"name": "Jan Karon"},\r\n    "111": {"name": "Alex Kava"},\r\n    "112": {"name": "Faye Kellerman"},\r\n    "113": {"name": "Jonathan Kellerman"},\r\n    "114": {"name": "Sherrilyn Kenyon"},\r\n    "115": {"name": "Sue Monk Kidd"},\r\n    "116": {"name": "Laurie R. King"},\r\n    "117": {"name": "Stephen King"},\r\n    "118": {"name": "Karen Kingsbury"},\r\n    "119": {"name": "Barbara Kingsolver"},\r\n    "120": {"name": "Sophie Kinsella"},\r\n    "121": {"name": "Lisa Kleypas"},\r\n    "122": {"name": "Dean Koontz"},\r\n    "123": {"name": "Jayne Ann Krentz"},\r\n    "124": {"name": "Dennis Lehane"},\r\n    "125": {"name": "John Lescroart"},\r\n    "126": {"name": "Beverly Lewis"},\r\n    "127": {"name": "Ken Liu"},\r\n    "128": {"name": "Debbie Macomber"},\r\n    "129": {"name": "Susan Mallery"},\r\n    "130": {"name": "Phillip Margolin"},\r\n    "131": {"name": "George R. R. Martin"},\r\n    "132": {"name": "Steve Martini"},\r\n    "133": {"name": "Alexander McCall Smith"},\r\n    "134": {"name": "Terry McMillan"},\r\n    "135": {"name": "Brad Meltzer"},\r\n    "136": {"name": "Fern Michaels"},\r\n    "137": {"name": "Sue Miller"},\r\n    "138": {"name": "Mary Alice Monroe"},\r\n    "139": {"name": "Liane Moriarty"},\r\n    "140": {"name": "Kate Morton"},\r\n    "141": {"name": "Sarah Moss"},\r\n    "142": {"name": "JoJo Moyes"},\r\n    "143": {"name": "Carla Neggers"},\r\n    "144": {"name": "Jo Nesbo"},\r\n    "145": {"name": "Joyce Carol Oates"},\r\n    "146": {"name": "Nnedi Okorafor"},\r\n    "147": {"name": "Sara Paretsky"},\r\n    "148": {"name": "T. Jefferson Parker"},\r\n    "149": {"name": "Ann Patchett"},\r\n    "150": {"name": "James Patterson"},\r\n    "151": {"name": "Richard North Patterson"},\r\n    "152": {"name": "Louise Penny"},\r\n    "153": {"name": "Anne Perry"},\r\n    "154": {"name": "Jodi Picoult"},\r\n    "155": {"name": "Douglas Preston"},\r\n    "156": {"name": "Amanda Quick"},\r\n    "157": {"name": "Anna Quindlen"},\r\n    "158": {"name": "Ian Rankin"},\r\n    "159": {"name": "Kathy Reichs"},\r\n    "160": {"name": "Taylor Jenkins Reid"},\r\n    "161": {"name": "Luanne Rice"},\r\n    "162": {"name": "Francine Rivers"},\r\n    "163": {"name": "Karen Robards"},\r\n    "164": {"name": "J. D. Robb"},\r\n    "165": {"name": "Nora Roberts"},\r\n    "166": {"name": "James Rollins"},\r\n    "167": {"name": "Patrick Rothfuss"},\r\n    "168": {"name": "Brandon Sanderson"},\r\n    "169": {"name": "John Sandford"},\r\n    "170": {"name": "John Scalzi"},\r\n    "171": {"name": "Lisa Scottoline"},\r\n    "172": {"name": "Lisa See"},\r\n    "173": {"name": "Jeff Shaara"},\r\n    "174": {"name": "Anita Shreve"},\r\n    "175": {"name": "Daniel Silva"},\r\n    "176": {"name": "Karin Slaughter"},\r\n    "177": {"name": "Nicholas Sparks"},\r\n    "178": {"name": "Danielle Steel"},\r\n    "179": {"name": "Elizabeth Strout"},\r\n    "180": {"name": "Amy Tan"},\r\n    "181": {"name": "Donna Tartt"},\r\n    "182": {"name": "Nancy Thayer"},\r\n    "183": {"name": "Brad Thor"},\r\n    "184": {"name": "Adriana Trigiani"},\r\n    "185": {"name": "Scott Turow"},\r\n    "186": {"name": "Anne Tyler"},\r\n    "187": {"name": "Lisa Unger"},\r\n    "188": {"name": "Jeff VanderMeer"},\r\n    "189": {"name": "Jeannette Walls"},\r\n    "190": {"name": "Ruth Ware"},\r\n    "191": {"name": "Jennifer Weiner"},\r\n    "192": {"name": "Andy Weir"},\r\n    "193": {"name": "Martha Wells"},\r\n    "194": {"name": "Randy Wayne White"},\r\n    "195": {"name": "Colson Whitehead"},\r\n    "196": {"name": "Susan Wiggs"},\r\n    "197": {"name": "Jacqueline Winspear"},\r\n    "198": {"name": "Sherryl Woods"},\r\n    "199": {"name": "Stuart Woods"}\r\n}';
const $6ebf28e7af071060$var$biJson = JSON.parse($6ebf28e7af071060$var$_biJson);
const $6ebf28e7af071060$export$545bf518be75e25a = ()=>{
    // Slide information
    const container = document.getElementById('bookit');
    const displayNum = 10;
    const author = ()=>{
        const id = $b3578e6e7db5838b$export$b141de964f0a90c1(199);
        return `<picture class="bookit-img">
            <img src="/img/bookit/${id}.jpg" alt="${$6ebf28e7af071060$var$biJson[id].name}" type="image/jpeg">
        </picture>`;
    };
    // Add inital content set
    for(let i = 0; i < displayNum; i++)container.innerHTML += author();
    // Shift logic
    const shift = ()=>{
        // Remove first child, add new random
        container.removeChild(container.firstElementChild);
        container.innerHTML += author();
        // Update children list
        const children = Array.from(container.children);
        // Advance slide
        children.forEach((child, i)=>child.style.transform = `translateX(${(i - 2) * 100}%)`);
        setTimeout(()=>{
            children.forEach((child, i)=>child.style.transform = `translateX(${(i - 3) * 100}%)`);
        }, 20);
    };
    // Auto-advance
    shift();
    setInterval(shift, 12000);
};



var $e454c71bc1df17ec$exports = {};

$e454c71bc1df17ec$exports = (parcelRequire("gV3Os")).getBundleURL('5QiRL') + "calendar.8ac659bd.json";


var $cf930632ececd68c$exports = {};

$cf930632ececd68c$exports = (parcelRequire("gV3Os")).getBundleURL('5QiRL') + "hashcache.7defbf8b.json";


// Get page details
const $271687ec8517cf4a$var$url = window.location.href;
let $271687ec8517cf4a$var$page;
try {
    $271687ec8517cf4a$var$page = $271687ec8517cf4a$var$url.split("/")[3];
    $271687ec8517cf4a$var$page = $271687ec8517cf4a$var$page.split(".")[0];
} catch (e) {
    $271687ec8517cf4a$var$page = '';
}
// Autoscroll if linked (default)
const $271687ec8517cf4a$var$autoScroll = ()=>{
    const urlClean = $271687ec8517cf4a$var$url.split("#")[1];
    if (urlClean) {
        const scrollId = document.getElementById(urlClean);
        scrollId.scrollIntoView();
    }
};
// Content to inject for events page
const $271687ec8517cf4a$var$contentEvents = (res)=>{
    $4b42aeb6089abef0$export$20e0353d92eda19d(res, $62d9c6abc6c16b60$export$461939dd4422153);
    let curMonth = $62d9c6abc6c16b60$export$461939dd4422153.getMonth();
    let curYear = $62d9c6abc6c16b60$export$461939dd4422153.getFullYear();
    let lastDate = new Date(curYear, curMonth - 1, 1);
    let nextDate = new Date(curYear, curMonth + 1, 1);
    let lastLimit = new Date(curYear, curMonth, 1);
    let nextLimit = new Date(curYear, curMonth + 3, 1);
    let disableLeft = true;
    let disableRight = false;
    $b3578e6e7db5838b$export$187b105aa6466800((e)=>{
        const navLeft = document.getElementById("calendar-nav-back");
        const navRight = document.getElementById("calendar-nav-next");
        if (navLeft.contains(e.target) && !disableLeft) {
            $4b42aeb6089abef0$export$20e0353d92eda19d(res, lastDate);
            curMonth = lastDate.getMonth();
            curYear = lastDate.getFullYear();
            if (lastDate.getTime() === lastLimit.getTime()) {
                navLeft.classList.add("calendar-action-grey");
                disableLeft = true;
            }
            navRight.classList.remove("calendar-action-grey");
            disableRight = false;
            lastDate = new Date(curYear, curMonth - 1, 1);
            nextDate = new Date(curYear, curMonth + 1, 1);
        } else if (navRight.contains(e.target) && !disableRight) {
            $4b42aeb6089abef0$export$20e0353d92eda19d(res, nextDate);
            curMonth = nextDate.getMonth();
            curYear = nextDate.getFullYear();
            if (nextDate.getTime() === nextLimit.getTime()) {
                navRight.classList.add("calendar-action-grey");
                disableRight = true;
            }
            navLeft.classList.remove("calendar-action-grey");
            disableLeft = false;
            lastDate = new Date(curYear, curMonth - 1, 1);
            nextDate = new Date(curYear, curMonth + 1, 1);
        }
    });
    $271687ec8517cf4a$var$autoScroll();
};
// Search bar
const $271687ec8517cf4a$var$search = ()=>{
    const searchForm = document.getElementById('search');
    searchForm.addEventListener("submit", (e)=>{
        let keyword = document.getElementById('query').value;
        e.preventDefault();
        if (keyword !== '') {
            keyword.replace(' ', '+');
            window.location.replace(`https://raritan.aspendiscovery.org/Union/Search?view=list&lookfor=${keyword}&searchIndex=Keyword&searchSource=local`);
            return false;
        }
    });
};
const $271687ec8517cf4a$var$pageInjector = (p)=>{
    if (p === '') {
        $27b556cf1e8c5b43$export$124049a9e3d0d4c3();
        $6ebf28e7af071060$export$545bf518be75e25a();
    }
    if (p === 'bookit') $6ebf28e7af071060$export$545bf518be75e25a();
    if (p.includes('board')) $271687ec8517cf4a$var$autoScroll();
};
$915ccb9ee672fb9f$export$81207e5cc4186890();
$915ccb9ee672fb9f$export$4bd4b47501432316();
$388eee12b32806dc$export$513ccb98c53b8039();
// Load event/hashcache data
const $271687ec8517cf4a$var$eventResFunc = async (res)=>{
    res = res.events;
    const cache = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($cf930632ececd68c$exports)))).then((x)=>x.json());
    $4b42aeb6089abef0$export$d118786f359a8bfd(res, cache);
    if ($271687ec8517cf4a$var$page.includes('events')) $271687ec8517cf4a$var$contentEvents(res);
};
$b3578e6e7db5838b$export$f46232c2a9c34923((0, (/*@__PURE__*/$parcel$interopDefault($e454c71bc1df17ec$exports))), $271687ec8517cf4a$var$eventResFunc);
window.onload = ()=>{
    $62d9c6abc6c16b60$export$813e98560751a081();
    $271687ec8517cf4a$var$pageInjector($271687ec8517cf4a$var$page);
    $388eee12b32806dc$export$f543642fc33c1018();
    $388eee12b32806dc$export$dd08b95ed5ec19a6();
    $4b42aeb6089abef0$export$e85a8dcc29475cfa();
    $271687ec8517cf4a$var$search();
};


//# sourceMappingURL=403.8a0470b3.js.map
